import { Component, computed, DestroyRef, effect, ElementRef, inject, NgZone, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { DataRepositoryService } from "../../../shared/services/data-repository/data-repository.service";
import { IPlannedPBMTasksMap, ITasksMap, plPBMDeltaUpdates } from "../../../shared/models/tasks-planned";
import { TaskInfoService } from "../../../shared/services/task-info/task-info.service";
import { DataAccessService } from "../../../shared/services/data-access/data-access.service";
import { interval, mergeMap, Subject, Subscription, take, takeWhile } from "rxjs";
import { MessageService } from "primeng/api";
import { ErrorMessage, ErrorType, WarningMessage } from "../../../shared/entity/error.const";
import { Coordinate } from "../../../shared/models/business-location-details";
import { Table } from "primeng/table";
import { LoaderService } from "../../../shared/services/loader/loader.service";
import "leaflet-draw";
import { StopState, TaskState, TaskType } from "../../../shared/models/core";
import { MapViews, RouteState, PlannedSequenceType, TBTabName, DataGroupingTypes } from "../../../shared/entity/enums";
import { ConnectionService } from "../../../shared/services/connection/connection.service";
import { GPSResponse, PlannedSubscriptionData } from "../../../shared/entity/utility-interfaces";
import { AppConstants, IntervalDuration } from "../../../shared/entity/constants";
import { TaskMovementService } from "../../../shared/services/operations/task-movement.service";
import { MapLeafletService } from "../services/mapLeaflet.service";
import { Routes } from "../../../shared/models/kpi-details";

import { IUPPTasksMap, unplannedDeltaUpdates } from "../../../shared/models/task-unplannedpickup";
import { IUnloadedTasksMap, unloadedDeltaUpdates } from "../../../shared/models/task-unloaded";
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CircleMarker } from "leaflet";
import { ColorCodesExtraMarker } from "../../../shared/entity/color-codes";
import { Router } from "@angular/router";
import { Navigation } from '../../../shared/entity/navigation';
import { TaskbankColumnFilterService } from "../../home/dashboard/task-bank/column-service/taskbank-column-filter.service";
import { LayoutStateService } from "src/app/shared/services/layout-state/layout-state.service";
import { LayoutPane } from "src/app/shared/entity/layout-presets";


/**
 * Leaflet const declaration: substitute of -> import * as L from "leaflet";
 * To enable leaflet-draw plugin 
 */
declare const L: any; 

type customCircleMarkerType = Partial<L.CircleMarker> & {
  uniqueID?: string;
  parentId?: string;
  isSelected?: boolean;
  type?: string;
};

type CustomMarkerType = Partial<L.Marker> & {
  uniqueID?: string;
  parentId?: string;
  type?: string;
};

type CustomPolylineMarkerType = Partial<L.Polyline> & {
  uniqueID?: string;
  parentId?: string;
  type?: string;
};

type CustomFeatureGroupType = Partial<L.FeatureGroup> & {
  uniqueID?: string;
};

@Component({
    selector: "app-map-leaflet",
    templateUrl: "./mapLeaflet.component.html",
    styleUrls: ["./mapLeaflet.component.scss",
        '../../../shared/css/primeng-dropdown.component.scss',
        '../../../shared/css/primeng-table.component.scss'],
    standalone: false
})
export class MapLeafletComponent implements OnInit, OnDestroy {
  @ViewChild("mapTable") mapTable: Table = {} as Table;
  @ViewChild('mapContainer') mapLeafletContainer: ElementRef = {} as ElementRef;

  mapRef : HTMLElement | null= null;
  mapID = 'mapSeperateContainer'
  
  public map: any;
  coordinatesArray: [number, number][] = [];
  mapData: ITasksMap[] = [];
  longitude: number = 0;
  loading: boolean = false;
  latitude: number = 0;
  lastSelectedRoute: any;
  kpiData: any[] = [];
  subscription: Subscription[] = [];
  polyLineRouteId: string = "";
  oldSelectedBL: string = "";
  newSelectedBL: string = "";
  blCoordinates: any;
  selectedKPIRoutes: any[] = [];
  routesColor: any;
  routeSelectionDisabled = false;
  checkboxCheckedCount = 0;
  blCoordsArray: [number, number][] = [];
  coords: [number, number][] = [];
  sectionVisible = 0; // 0 - all, 1 - KPI, 2 - unplanned section
  isTableCollapsed: boolean = false;
  blName: string = '';
  taskData: any;
  layerGroup: L.LayerGroup = L.layerGroup();
  routeLayerGroup: L.LayerGroup[] = [];
  groupRoute: any;
  isStopView: boolean = false;
  currentZoomLevel: number = 12;
  gpsDataMap: Map<string, any> = new Map<string, any>();
  gpsResponse: GPSResponse = {} as GPSResponse;
  gpsSubscription: Subscription = Subscription.EMPTY;
  plannedTaskSubscription: Subscription = Subscription.EMPTY;
  plottedRouteList: any[] = [];
  drawnShapes: L.FeatureGroup<any> = L.featureGroup();
  markers: L.Marker[] = [];
  drawnPolygonMap: Map<string, any> = new Map<string, any>();
  gpsMarkerMap: Map<string, any> = new Map<string, any>();
  gpsMarkerFG: L.FeatureGroup<any> = L.featureGroup();
  mergedViewFG: L.FeatureGroup<any> = L.featureGroup();
  selectedView: string = TBTabName.Unplannedpickup; 
  isToggleLineBtnVisible: boolean = false;
  isZoomLessThanThreshold: boolean = true;
  zoomLevelIsLess: boolean = true;
  isAddressMarkersVisible: boolean = false;
  isMergedViewVisible: boolean = false; //  if merged view (planned routes) is currently visible
  /**
   * This collection replicates the selectedTask list for later use in reseting the global lighting
   */
  selectedTaskMove:any = [];

  private resizeObserver: ResizeObserver = new ResizeObserver(() => {});
  private mapCenter: L.LatLng = L.latLng(0, 0);
  readonly #destroyRef = inject(DestroyRef);

  plannedPbmData: IPlannedPBMTasksMap[] = [];
  unplannedData: IUPPTasksMap[] = [];
  pushToCloudData: IUPPTasksMap[]=[];
  unloadedData: IUnloadedTasksMap[] = [];
  routePtAddressPtMarkers: CircleMarker[] = [];
  lastMarkerClickedId: { route_id: string | null, task_id: string | null} = { route_id: null, task_id: null };
  zoomLevelForAddressPtMarker: number = 16;

  //
  RoutePage: string;
  navigation = Navigation;
  readonly mapPaneVisible = this.layoutStateService.isPaneVisible(LayoutPane.Map);
  readonly mapPaneSize = this.layoutStateService.getPaneSize(LayoutPane.Map);
  readonly routeListPaneSize = this.layoutStateService.getPaneSize(LayoutPane.RouteList);
  readonly ganttPaneSize = this.layoutStateService.getPaneSize(LayoutPane.Gantt);
  readonly taskBankPaneSize = this.layoutStateService.taskBankSize;
  readonly topRegionPaneSize = computed(() => 100 - this.taskBankPaneSize());

  viewOptions = [
    { label: "Task view", value: MapViews.TaskView },
    { label: "Stop view", value: MapViews.StopView },
    { label: "Unplanned Pickup", value: TBTabName.Unplannedpickup },
    { label: "Unloaded", value: TBTabName.Unloaded },
    { label: "Planned PBM", value: TBTabName.PlannedPBM },
    { label: "Push to cloud", value: TBTabName.PushToCloud },
  ];

  constructor(
    public dataRepositoryService: DataRepositoryService,
    public taskInfoService: TaskInfoService,
    readonly dataAccessService: DataAccessService,
    readonly messageService: MessageService,
    readonly loaderService: LoaderService,
    readonly connectionService: ConnectionService,
    readonly taskMovementService: TaskMovementService,
    public mapLeafletService: MapLeafletService,
    private readonly router: Router,
    private readonly ngZone: NgZone,
    private readonly taskBankColumnFilterService: TaskbankColumnFilterService,
    private readonly layoutStateService: LayoutStateService
  ) {
    this.constructorSubscriptions();
    this.RoutePage = this.router.url;

    effect(()=>{
      if(this.taskMovementService.taskmoveCount()){
        this.selectedTaskMove = [...this.taskMovementService.selectedOptionsForTaskMove];
      }
    });
  }

  //*************Lifecycle hooks STARTS*************//

  ngOnInit(): void {
    this.oldSelectedBL = this.dataRepositoryService.selectedBusinessLocation;
    this.newSelectedBL = this.dataRepositoryService.selectedBusinessLocation;
    this.blCoordinates = this.dataRepositoryService.blCoordinates;
    this.initializeSubscriptions();
    this.checkTabSelection();
    if(this.router.url ===  this.navigation.Landing) {
      this.mapID = 'mapLandingContainer';
    } else {
      this.mapID = 'mapSeperateContainer';
    }
  }

  ngAfterViewInit() {
    //subscription handles split view to show/hide sections 
    this.mapRef = document.getElementById(`${this.mapID}`);
    this.loaderService.expand$.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe((data) => {
      if (data !== null) {
        this.sectionVisible = data;
        this.setSectionVisibility(this.sectionVisible);
      }
    });


    this.loadKPIData();
    let bl: any = this.dataRepositoryService.selectedBusinessLocation;
    this.blName =
      this.dataRepositoryService.businessLocationListMap.get(bl)?.name ?? "";
    let blCoords = this.dataRepositoryService.blCoordinates;
    //check if BL coordinates are available then render map and BL marker
    if (blCoords !== undefined) {
      this.renderMap(blCoords);
      this.setBLMarker(blCoords);
      this.setMapFocus(blCoords, this.currentZoomLevel ?? 12);
    }
    //else render only map tiles.
    else{
      this.renderMap(blCoords);
    }
    if (this.map && this.layerGroup) {
      this.checkActiveTabForPlotting();
      //check if map object readiness then initialize the resize observer
      this.observeResize();
    }
  }

  ngOnDestroy(): void {
    this.subscription.forEach((item) => item.unsubscribe());
    this.resizeObserver.disconnect();
    this.map?.remove();
    //clear those collection/variables which are used in Map view only but declared in other classes
    this.dataRepositoryService.highlightedTaskOnMap.clear();
  }
  //***********************Lifecycle hooks ENDS******************** */
  
  /**
   * Method will set isSplitDragged true
   * to ensure filter would hide if open
   */
  onSplitDragEnd() {
    this.taskBankColumnFilterService.setIsSplitDragged();
  }
  /**
   * Method collects all has subscrition method calls which begins 
   * in constructor stage. 
   */
  constructorSubscriptions(){
    this.isSelectedFromTaskBankSubs();
    this.isTBTabSwitchedSubs();
    this.taskMovementSuccessSubs();
    this.resetButtonClickedSubs();
    this.isFavBLChangedSubs();
  }

  /**
   * Method initiate the subscriptions for the component, any new subscription 
   * method added in the component, should be called here to get initialized. 
   */
  initializeSubscriptions(){
    this.kpiDataSubs();
    this.kpiDeltaSubs();
    this.filterAppliedSubs();
    this.isPlannedSelectedSubs();
    this.isUnplannedSelectedSubs();
    this.isPlannedPBMSelectedSubs();
    this.isPushToCloudSelectedSubs();
    this.isUnloadedItemSelectedSubs();
  }

  /*************SUBSCRIPTION METHODS STARTS**************/

  /**
   * Method has KPIData subscription
   */
  kpiDataSubs(){
    this.subscription.push(
      this.dataAccessService.kpiData$.subscribe((data) => {
        if (data) {
          this.selectedKPIRoutes = [
            ...this.dataRepositoryService.selectedRouteList,
          ];
          this.newSelectedBL =
            this.dataRepositoryService.selectedBusinessLocation;
          this.blCoordinates = this.dataRepositoryService.blCoordinates;

          let plottedRoutes = [...this.plottedRouteList];
          //check selected and plotted routes are available in new routelist
          plottedRoutes?.forEach((kpiRoute) => {
            const newRouteList =
              this.dataRepositoryService.routesList[0].routes;
            if (newRouteList.length) {
              if (
                !this.dataRepositoryService.routesList[0].routes
                  .map((m) => m.route_id)
                  ?.includes(kpiRoute.key)
              ) {
                const removeRoute = {
                  isChecked: false,
                  routeId: kpiRoute.key,
                  routeState: kpiRoute.values[0].route_state,
                };
                //check if last route selected also needs to be removed
                if(this.lastSelectedRoute?.routeId===removeRoute.routeId){
                  this.lastSelectedRoute = {};
                }
                this.removeDeselectedRoute(removeRoute);
              }
            }
          });
          //******Testing the published method after removal  */
          this.taskInfoService.publishUpdates();

          this.plotAllRoutes(this.selectedKPIRoutes);
          //load KPI and check if GPS call is required
          if (this.dataRepositoryService.kpiDataMap.size) {
            this.loadKPIData();
          }
          else {
            this.loading = false;
            this.kpiData = [];
            this.messageService.add({
              severity: ErrorType.ERROR,
              summary: "",
              detail: ErrorMessage.NOROUTE,
            });
          }
        }
      })
    );
  }

  /**
   * Method has KPI delta subscription
   */
  kpiDeltaSubs(){
    this.subscription.push(
      this.dataAccessService.kpiDeltaUpdates$.subscribe((data: any) => {
        if (data) {
          if (this.dataRepositoryService.kpiDataMap.size) {
            this.loadKPIData();
            /**
             * NOTE: Use below code with GPS subscription check, if required.
             * TO run GPS only if it is not already running.  
             */
            /**
             if (
               this.validateGPSActivation()
             ) {
               this.checkGPSOnSelectedRoute();
             }
             */
          }
        }
      })
    );
  }

  /**
   * Method has filter subscription
   */
  filterAppliedSubs(){
    this.subscription.push(
      this.dataAccessService.fitlerApplied$.subscribe((data) => {
        if (data) {
          //filter BL change is triggered, planned data gets cleared.
          this.isMergedViewVisible = false; // Reset merged view when filter is applied
          this.blCoordinates = this.dataRepositoryService.blCoordinates;
          this.newSelectedBL =
            this.dataRepositoryService.selectedBusinessLocation;
          this.resetTaskMap();
          this.resetComponentVariables();
          this.clearRoutesColorMap();
          this.clearGPSSubscription();
          if (this.dataRepositoryService.kpiDataMap.size) {
            this.loadKPIData();
          } else {
            this.loading = false;
            this.kpiData = [];
            this.selectedKPIRoutes = [];
            this.messageService.add({
              severity: ErrorType.ERROR,
              summary: "",
              detail: ErrorMessage.NOROUTE,
            });
            this.setMapControlButtonVisibility(); // Hide Show Planned button
          }
          this.scrollToTop();
        }
      })
    );
  }

  /**
   * Method has planned route selection subscription
   */
  isPlannedSelectedSubs(){
    this.subscription.push(
      this.dataAccessService.isPlannedSelected$.subscribe(
        (plannedData: any) => {
          //check map control buttons state
        //  this.setPolylineBtnVisibility();

          const taskData: PlannedSubscriptionData = { ...plannedData };
          /**
           * ******Update task work
           */
          this.mapData = [
            ...this.dataRepositoryService.plannedTbCollection.values(),
          ];
          const isPlannedTabActive =
            this.taskInfoService.selectedTabName.toLowerCase() ===
            TBTabName.Planned.toLowerCase();
          const isMergedViewTabActive = this.isMergedViewSupportedTab();

          //perform a sorting of the object based on selected view either by task sequence or stop sequence
          this.mapData = this.isStopView
            ? this.sortBySequence(this.mapData, PlannedSequenceType.StopSequence)
            : this.sortBySequence(this.mapData, PlannedSequenceType.TaskSequence);

            if(this.mapData.length && isPlannedTabActive){
              this.selectedView = this.isStopView ? MapViews.StopView :  MapViews.TaskView
            }
            
            /**
             * Check if highlighting effects if required for existing plotted route,
             * delta changes may removed an existing highlighted marker so its entry 
             * should be removed from repo.
             */
            if (this.dataRepositoryService.highlightedTaskOnMap.size) {
              this.updateHighlightedTaskList();
            } 
            
            // Check if the view has changed to planned and merged view is not visible
            if(this.taskInfoService.isViewChangedToPlanned && !this.isMergedViewVisible){
              if(this.isStopView) {
                this.plotPlannedStopView();
              } else {
                this.plotPlannedTaskView();
              }
              /**
               * This below method would be used in next release
               */
              // this.setMarkerInclusion();
              this.taskInfoService.isViewChangedToPlanned = false;
            } else if (isMergedViewTabActive && this.isMergedViewVisible) { // Check if the view has changed to merged and merged view is visible
              this.plotMergedView();
            }else if (taskData.isDeltaUpdate) { // Check if the task data contains delta updates
              if (taskData.deltaUpdates.length || taskData?.removedTasks?.length) {
                //get the zoom level, and use it after replotting of the map
                this.currentZoomLevel = this.map?.getZoom();
                this.updateDeltaChanges(taskData);
                //GPS
                if (this.validateGPSActivation()) {
                  this.checkGPSOnSelectedRoute();
                }
              }
            } else { // Handle the case when there are no delta updates and the view is not merged
              if (isPlannedTabActive && this.mapData.length && this.lastSelectedRoute?.isChecked) {
                if (this.selectedKPIRoutes) {
                  //check if the route ID is already available in plotting or not
                  if(!this.plottedRouteList.some((route: any) => route.key == this.lastSelectedRoute.routeId)){
                    //set the map focus and current zoom
                    this.groupRoutes(this.lastSelectedRoute.routeId);
                    // when new route is selected check the GPS 
                    this.checkGPSOnSelectedRoute(this.lastSelectedRoute);
                  }

                  //recenter the map to cover all the plotting inside map viewport
                  /**
                    * This below method would be used in next release
                  */
                  // this.setMarkerInclusion();
                  //get the centriod
                  /**
                   * To be used : When all markers are required to appear in map view using centriod, use below method call
                  const centroid = this.getCentroid(this.mapLeafletService.markers);

                  if (centroid) {
                    console.log(`centriod point ${centroid}`);
                  }
                   */
                }
              }
              if(!this.mapData.length){
                //clear any old planned plotting route layers if data is empty
                if(isPlannedTabActive){
                  this.layerGroup?.clearLayers();
                  this.map && 
                  this.setBLMarker(this.blCoordinates);
                  this.setMapFocus(this.blCoordinates, this.currentZoomLevel ?? 12);
                }
                else{
                  this.map && 
                  this.setMapFocus(this.blCoordinates, 8);
                }
              }
            }
            this.setMapControlButtonVisibility();
            /**
             * *********update task work ends
             */
        }
      )
    );
  }


  /**
   * Unplanned pickup tasks subscription
   *
   * **********NOTE*******
   * Use this subscription, if UPP tasks are required to be shown on Map
   */
  isUnplannedSelectedSubs(){
    this.subscription.push(
      this.dataAccessService.isunplannedselected$.subscribe((unplannedData:unplannedDeltaUpdates) => {
        if (unplannedData) {
          //proceed if map object is ready in DOM
          this.unplannedData = [...this.dataRepositoryService.unplannedTbCollection.values()];
          if(this.taskInfoService.selectedTabName.toLowerCase()==TBTabName.Unplannedpickup.toLowerCase()){
            this.updateOtherTaskOnDelta(unplannedData);
            this.plotOtherTasks(this.unplannedData, unplannedData);
            this.selectedView = TBTabName.Unplannedpickup;
            this.setMapControlButtonVisibility();
          }
        }
      })
    );
  }

  /**
   * plannedPBM pickup tasks subscription
   */
  isPlannedPBMSelectedSubs(){
    this.subscription.push(
      this.dataAccessService.isPlannedPBMselected$.subscribe(
        (plannedPbmData:plPBMDeltaUpdates) => {
          //proceed if map object is ready in DOM
          if (this.map && this.layerGroup) {
            if (plannedPbmData) {
              this.plannedPbmData = [...this.dataRepositoryService.plannedPbmTbCollection.values()];
              if(this.taskInfoService.selectedTabName.toLowerCase()==TBTabName.PlannedPBM.toLowerCase()){
                this.updateOtherTaskOnDelta(plannedPbmData);
                this.plotOtherTasks(this.plannedPbmData, plannedPbmData);
                this.selectedView = TBTabName.PlannedPBM;
                this.setMapControlButtonVisibility();
              }
            }
          }
        }
      )
    );
  }

  /**
   * Method has PushToCould task selection subscription
   */
  isPushToCloudSelectedSubs(){
    this.subscription.push(
      this.dataAccessService.isCloudSelected$.subscribe((cloudData:unplannedDeltaUpdates) => {
        //proceed if map object is ready in DOM
        if (this.map && this.layerGroup) {
          if (cloudData) {
            this.pushToCloudData = [...this.dataRepositoryService.cloudTbCollection.values()];
            if(this.taskInfoService.selectedTabName.toLowerCase()==TBTabName.PushToCloud.toLowerCase()){
              this.updateOtherTaskOnDelta(cloudData);
              this.plotOtherTasks(this.pushToCloudData, cloudData);
              this.selectedView = TBTabName.PushToCloud;
              this.setMapControlButtonVisibility();
            }
          }
        }
      })
    );
  }

  /**
   * Method has unloaded Item selection subscription
   */
  isUnloadedItemSelectedSubs(){
    this.subscription.push(
      this.dataAccessService.isUnloadedSelected$.subscribe((unloadedData:unloadedDeltaUpdates) => {
        //proceed if map object is ready in DOM
        if (this.map && this.layerGroup) {
          if (unloadedData) {
            this.unloadedData = [...this.dataRepositoryService.unloadedTbCollection.values()];
            if(this.taskInfoService.selectedTabName.toLowerCase()==TBTabName.Unloaded.toLowerCase()){
              this.updateOtherTaskOnDelta(unloadedData);
              this.plotOtherTasks(this.unloadedData, unloadedData);
              this.selectedView = TBTabName.Unloaded;
              this.setMapControlButtonVisibility();
            }
          }
        }
      })
    )
  }

  /**
   * Method has TaskBank row selection subscription,
   * subscription informs map about the task selection in task bank
   */
  isSelectedFromTaskBankSubs(){
    this.subscription.push(
      this.taskInfoService.isSelectedFromTaskBank$.subscribe((res: any) => {
        if (res) {
          if (!this.isStopView) {
            //show the highlighting effect IF res.isSelectedFromPlannedTable property is TRUE
            if(res.isSelectedFromPlannedTable){
              this.setHighlightedTask(res.taskId, res.routeId);
            }
            //Hide the highlighting effect IF res.isSelectedFromPlannedTable property is FALSE
            else{
              this.resetHighlightedTask(res.taskId, res.routeId);
            }
          } else {
            this.informUser(
              ErrorMessage.TASKSELECTIONWARNING,
              ErrorType.WARNING
            );
          }
        }
      })
    );
  }

  /**
   * Method has task bank tab switch event subscription
   */
  isTBTabSwitchedSubs(){
    this.subscription.push(
      this.dataAccessService.isTBTabSwitched$.subscribe(
        (isTabSwitched: boolean) => {
          if (isTabSwitched) {
            this.isMergedViewVisible = false;
            this.resetTaskMap();
            this.checkTabSelection();
            this.setMapControlButtonVisibility();
          }
        }
      )
    );
  }

  /**
   * Method has task movement success event subscription
   */
  taskMovementSuccessSubs(){
    this.subscription.push(
      this.taskMovementService.taskMovementSuccess.subscribe((res: any) => {
        if (res?.success) {
          this.removePolygon();
        }
      })
    );
  }

  /**
   * Method has reset button trigger event subscription
   */
  resetButtonClickedSubs(){
    this.subscription.push(
      this.taskMovementService.resetButtonClicked.subscribe((res: any) => {
        if (res) {
          this.removePolygon();

          const selectedTaskList = this.taskMovementService
            .selectedOptionsForTaskMove.length
            ? this.taskMovementService.selectedOptionsForTaskMove
            : this.selectedTaskMove;
          const highlightedRoutes = this.mapLeafletService.groupCollection(
            selectedTaskList,
            DataGroupingTypes.RouteID
          );
          highlightedRoutes?.forEach((route: any) => {
            let routeId = route.key;
            let tasks = route.values;
            //iterate through each tasks
            tasks?.forEach((task: any) => {
              this.resetHighlightedTask(task.task_id, routeId);
            });
          });
        }
      })
    );
  }

  /**
   * Method has favoriteBL change event subscription,
   * it replots the map with new BL data 
   */
  isFavBLChangedSubs(){
    this.subscription.push(
      this.dataAccessService.isFavBLChanged$.subscribe(
        (isFavBLChanged: boolean) => {
          if (isFavBLChanged) {
            this.isMergedViewVisible = false;
            this.resetTaskMap();
            this.checkTabSelection();
            this.setMapControlButtonVisibility();
          }
        }
      )
    )
  }

  
  /***********************SUBSCRIPTION METHODS ENDS****************************/
  

  /**
   * Method initializes the map object with default setting, sets the tile layer
   * and instantiates different leaflet feature objects.
   * @param blCoords Business location coordinates
   */
  renderMap(blCoords: any) {
    this.map = L.map(this.mapID, {
      center: blCoords ? [blCoords.latitude, blCoords.longitude]: [59.350072, 18.009896],
      zoom: blCoords ? 8: 6,
      attributionControl: false,
    });

    let streetMap = L.tileLayer(
      `https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png`,
      {
        maxNativeZoom: 18,
        maxZoom: 18,
        minZoom: 3,
      }
    );
    streetMap.addTo(this.map);

    //create layer group and add to map object
    this.layerGroup = L.layerGroup();
    this.layerGroup?.addTo(this.map);

    let drawnItems = new L.FeatureGroup();
    this.map?.addLayer(drawnItems);

    //shape collector
    this.drawnShapes = new L.FeatureGroup();
    this.map?.addLayer(this.drawnShapes);
    
    //GPS Marker collector
    this.gpsMarkerFG = new L.FeatureGroup();
    this.map?.addLayer(this.gpsMarkerFG);
    
    //Merged view (planned overlay)
    this.mergedViewFG = new L.FeatureGroup();
    this.map?.addLayer(this.mergedViewFG);
  
    //controls
    const drawControl = new L.Control.Draw({
      edit: {
        featureGroup: this.drawnShapes
      },
      draw: {
        polyline: false,
        circle: false,
        marker: false,
        rectangle: false,
        circlemarker: false,
        polygon: {
          allowIntersection: true,
          shapeOptions: {
            color: 'blue'
          }
        }
      }
    });

    this.map.addControl(drawControl);

    this.createEvent();
    this.editEvent();
    this.deleteEvent();
    this.zoomEvent();
    this.addCustomButton();   
  }

  /**
   * Method creates the custom HTML element button as control panel button
   * onClick of button, toggles the visibility of polyline for plotted routes
   * @returns HTML element if map object is initialized or else null
   */
  addCustomButton() {
    if (!this.map) return;

    const customControl = L.Control.extend({
      options: {
        position: 'topleft'
      },

      onAdd: (map: L.Map) => {
        const container = L.DomUtil.create('div', 'leaflet-control');
        container.style.border = 'none';
        container.style.boxShadow = 'none';
        this.addShowHideBtn(container);
        this.addShowHidePlannedBtn(container);
        this.setMapControlButtonVisibility();
        return container;
      },

      onRemove: (map: L.Map) => {
        // Nothing to do here
      }
    });
    this.map.addControl(new customControl());
  
  }

  /**
   * Method adds the show/hide polyline button to the specified container.
   * @param container The HTML element container to which the show/hide polyline button will be appended.
   */
   addShowHideBtn(container: HTMLElement) {
    const polylineBtn = L.DomUtil.create('button', 'pn-button pn-button-tertiary pn-button-xs mb-1');
    polylineBtn.style.display = 'block';
    polylineBtn.style.visibility = 'hidden';
    polylineBtn.style.pointerEvents = 'none';
    polylineBtn.id = 'polyline-btn';
    polylineBtn.textContent = this.dataRepositoryService.isMapPolylineVisible ? 'Hide Polyline' : 'Show Polyline';
    polylineBtn.onclick = () => {
      this.togglePolylineVisibility();
      this.updatePolylineButtonLabel();
    };
    polylineBtn.ondblclick = (e: any) => { e.stopPropagation(); return false; };
    container.appendChild(polylineBtn);
  }

  /**
   * Method adds the show/hide planned button to the specified container.
   * @param container The HTML element container to which the show/hide planned button will be appended.
   */
  addShowHidePlannedBtn(container: HTMLElement) {
      const plannedBtn = L.DomUtil.create('button', 'pn-button pn-button-tertiary pn-button-xs');
    plannedBtn.style.display = 'block';
    plannedBtn.style.visibility = 'hidden';
    plannedBtn.style.pointerEvents = 'none';
    plannedBtn.id = 'planned-btn';
    plannedBtn.textContent = this.isMergedViewVisible ? 'Hide Planned' : 'Show Planned';
    plannedBtn.onclick = () => {
      this.isMergedViewVisible = !this.isMergedViewVisible;
      this.toggleShowPlanned();
    };
    plannedBtn.ondblclick = (e: any) => { e.stopPropagation(); return false; };
    container.appendChild(plannedBtn);
  }

    updatePolylineButtonLabel() {
    const polylineBtn = L.DomUtil.get('polyline-btn');
    if (polylineBtn) {
      polylineBtn.textContent = this.dataRepositoryService.isMapPolylineVisible ? 'Hide Polyline' : 'Show Polyline';
    }
  }

  updatePlannedButtonLabel() {
    const plannedBtn = L.DomUtil.get('planned-btn');
    if (plannedBtn) {
      plannedBtn.textContent = this.isMergedViewVisible ? 'Hide Planned' : 'Show Planned';
    }
  }

  hasVisiblePolylineLayers(): boolean {
    const hasPlannedPolyline = this.layerGroup?.getLayers()?.some((layer: any) =>
      layer?.getLayers?.()?.some((innerLayer: any) => innerLayer?.type === 'polyline')
    );
    const hasMergedPolyline = this.mergedViewFG?.getLayers()?.some((routeFG: any) =>
      routeFG?.getLayers?.()?.some((layer: any) => layer?.type === 'planned-polyline-merged')
    );

    return Boolean(hasPlannedPolyline || hasMergedPolyline);
  }

  setMapControlButtonVisibility() {
    const polylineBtn = L.DomUtil.get('polyline-btn');
    if (polylineBtn) {
      const showPolylineBtn = this.hasVisiblePolylineLayers();
      polylineBtn.style.visibility = showPolylineBtn ? 'visible' : 'hidden';
      polylineBtn.style.pointerEvents = showPolylineBtn ? 'auto' : 'none';
      if (showPolylineBtn) {
        this.updatePolylineButtonLabel();
      }
    }

    const plannedWrapper = L.DomUtil.get('planned-btn');
    if (plannedWrapper) {
      const showPlannedBtn = this.isMergedViewSupportedTab() && this.selectedKPIRoutes.length > 0;
      plannedWrapper.style.visibility = showPlannedBtn ? 'visible' : 'hidden';
      plannedWrapper.style.pointerEvents = showPlannedBtn ? 'auto' : 'none';
      if (showPlannedBtn) {
        this.updatePlannedButtonLabel();
      }
    }
  }

  /*
   * Method checks if the currently active tab supports merged view (Unplanned Pickup, Unloaded, and Push to Cloud)
   * @returns boolean - true if merged view is supported on current tab
   */

  isMergedViewSupportedTab(): boolean {
    const currentTab = this.taskInfoService.selectedTabName.toLowerCase();
      return currentTab === TBTabName.Unplannedpickup.toLowerCase() ||
        currentTab === TBTabName.Unloaded.toLowerCase() ||
        currentTab === TBTabName.PushToCloud.toLowerCase();
  }

    /**
   * Method toggles the visibility of planned routes on the map
   * When enabled, plots planned routes alongside other task types (merged view)
   * When disabled, removes planned routes and keeps only the current task view
   * NOTE: This method should only be called on non-planned tabs
   */
  toggleShowPlanned() {
       // Prevent merged view on Planned tab
    if (this.taskInfoService.selectedTabName.toLowerCase() === TBTabName.Planned.toLowerCase()) {
      this.isMergedViewVisible = false;
      return;
    }

    if (this.isMergedViewVisible) {
      this.plotMergedView();
    } else {
      this.mergedViewFG?.clearLayers();
      this.resetTaskMap();
      if (this.taskInfoService.selectedTabName.toLowerCase() === TBTabName.Unplannedpickup.toLowerCase()) {
        this.plotOtherTasks(this.unplannedData);
      } else if (this.taskInfoService.selectedTabName.toLowerCase() === TBTabName.Unloaded.toLowerCase()) {
        this.plotOtherTasks(this.unloadedData);
      } else if (this.taskInfoService.selectedTabName.toLowerCase() === TBTabName.PushToCloud.toLowerCase()) {
        this.plotOtherTasks(this.pushToCloudData);
      }
    }

    this.setMapControlButtonVisibility();
  }

   /**
   * Method plots merged view with planned routes and current task type together
   * Gets planned data, groups by route, and plots them alongside existing task data
   */
  plotMergedView() {
    this.mergedViewFG?.clearLayers();

    const plannedTasks = [...this.dataRepositoryService.plannedTbCollection.values()];
    const selectedRouteIds = new Set(
      this.selectedKPIRoutes.map((route: any) => route.route_id)
    );
    const selectedPlannedTasks = plannedTasks.filter((task: any) =>
      selectedRouteIds.has(task.route_id)
    );
    if (selectedPlannedTasks.length === 0) {
      this.isMergedViewVisible = false;
      return;
    }
    const sortedPlannedTasks = this.sortBySequence(selectedPlannedTasks, PlannedSequenceType.TaskSequence);
    const groupedByRoute = this.mapLeafletService.groupCollection(sortedPlannedTasks, DataGroupingTypes.RouteID);

    groupedByRoute?.forEach((routeGroup: any) => {
      const routeId = routeGroup.key;
      const tasks = (routeGroup.values ?? []).filter((task: any) => this.hasValidCoordinates(task));
      if (!tasks.length) return;

      const routeFeatureGroup: any = L.featureGroup();
      routeFeatureGroup.addTo(this.mergedViewFG);

      this.plotMergedRouteMarkers(tasks, routeId, routeFeatureGroup);
      this.plotMergedRoutePolyline(tasks, routeId, routeFeatureGroup);
    });
  }

  private hasValidCoordinates(data: any): boolean {
    const coords = this.getCoordinates(data);
    return Boolean(coords?.latitude != null && coords?.longitude != null);
  }

  /**
   * Methods plots the markers for each route in the planned data for merged view
   * @param tasks: array of tasks for a specific route
   * @param routeId: route id for the specific route
   * @param routeFeatureGroup: feature group for the specific route
   */
  private plotMergedRouteMarkers(tasks: any[], routeId: string, routeFeatureGroup: any) {
    tasks.forEach((task: any) => {
      const coords = this.getCoordinates(task);
      const routeColor = this.dataRepositoryService.routesColour.get(routeId) || 'blue';

      const circleMarker: customCircleMarkerType = L.circleMarker(
        [coords.latitude, coords.longitude],
        { radius: 5, color: routeColor, fillColor: routeColor, fillOpacity: 0.6, weight: 2, opacity: 0.8 }
      );
      circleMarker.uniqueID = task.task_id;
      circleMarker.parentId = routeId;
      circleMarker.type = 'planned-marker-merged';

        circleMarker.addTo?.(routeFeatureGroup);
      circleMarker.bindPopup?.(
        `<b>Planned Task: ${task.task_sequence}</b><br/>Route: ${task.route_name || routeId}`
      );
    });
  }

   /**
   * method for polyline plotting for merged view, it plots the polyline for each route in the planned data
   * @param tasks : array of tasks for a specific route
   * @param routeId : route id for the specific route
   * @param routeFeatureGroup : feature group for the specific route
   */
  private plotMergedRoutePolyline(tasks: any[], routeId: string, routeFeatureGroup: any) {
    const lineCoords: [number, number][] = tasks.map((task: any) => {
      const coords = this.getCoordinates(task);
      return [coords.latitude, coords.longitude];
    });

    const polyline: CustomPolylineMarkerType = L.polyline(lineCoords, {
      color: this.dataRepositoryService.routesColour.get(routeId) || 'blue',
      weight: 2,
      opacity: this.dataRepositoryService.isMapPolylineVisible ? 0.5 : 0,
      dashArray: '5, 5',
      smoothFactor: 1,
    });
    polyline.uniqueID = routeId;
    polyline.parentId = routeId;
    polyline.type = 'planned-polyline-merged';
      polyline.addTo?.(routeFeatureGroup);
  }



  /*****Methods for Map Controls event *******/
  /**
   * Method handles the create event of the polygon control option
   */
  createEvent(){
    this.map.on(L.Draw.Event.CREATED, (e: any) => {
      let layer = e.layer;
      //unique id
      layer.uniqueID = crypto.randomUUID();
      layer.addEventListener("click", (event:any)=>{
        /**
         * Get polygon click event e.g. 
         * console.log(`polygon clicked ${event}, latlng ${event?.target.getLatLngs()[0]}`);
         */
      });
      //TRY
       let markerInsidePolygon: L.Marker[] = this.filterForMergedView(
        this.mapLeafletService.getFeaturesInsidePolygon(layer)
      );
      //update layer object with marker list inside it
      layer.markerList = markerInsidePolygon??[];
      if (
        this.taskInfoService.selectedTabName.toLowerCase() === TBTabName.Planned
      ) {
        let groupRoutes = this.mapLeafletService.groupCollection(
          markerInsidePolygon,
          "parentId"
        );
        layer.groupRoutes = groupRoutes.map((m:any)=>m.key);
      }
      this.drawnPolygonMap.set(layer.uniqueID, layer);
      this.drawnShapes?.addLayer(layer);
      //access the marker coming inside polygon
      /**
       * NOTE: This below implementation currently available for Planned data ONLY
       * use selectedTBTab name to set the condition accordingly. 
       */
      //Uncomment the below IF condition is future for all tab functionality
      if(this.taskInfoService.selectedTabName.toLowerCase() === TBTabName.Planned){
        //highlight the marker 
        this.setTaskMovementForPolygonsEdit(markerInsidePolygon);
      }
      this.mapLeafletService.getPolygonSelectedTaskInfo(markerInsidePolygon);
    }); 
  }

  /**
   * Method handles the edit event of the polygon control option
   */
  editEvent(){
    this.map.on(L.Draw.Event.EDITED, (event: any) => {
      //get all edited polygon layers
      let editedPolygons = event.layers.getLayers();
      //iterated through each polygon layer
      editedPolygons.forEach((polygon:any) => {
        this.updatePolygon(polygon, false);
      });
    });
  }

  /**
   * Method handles the delete event of the polygon control option
   */
  deleteEvent(){
    this.map.on(L.Draw.Event.DELETED, (event: any) => {
      /**
       * DELETE and UPDATE Task movement
       * 1. collect available layers after delete save event
       * 2. Reset task movement
       * 2. iterate through each layer and look for features inside it
       */
      // collect all layers
      let deletedPolygonLayers = event.layers.getLayers();

      let toBeRemovedTask: L.Marker<any>[] = [];
      deletedPolygonLayers.forEach((delPolygonLayer: L.Layer) => {
         const taskMarker = this.filterForMergedView(
          this.mapLeafletService.getFeaturesInsidePolygon(delPolygonLayer)
        );
        toBeRemovedTask.push(...taskMarker);
      });
      if (
        this.taskInfoService.selectedTabName.toLowerCase() === TBTabName.Planned
      ) {
        //get taskID from marker collection
        this.setTaskRemoveFromPolygonEdit(toBeRemovedTask);
      }
      this.mapLeafletService.getPolygonDeselectedTaskInfo(toBeRemovedTask);
    });
  }

  /**
   * Method handles zooom event
   */
  zoomEvent(){
    this.map.on('zoomend', (zoom: any) => {
      
      this.currentZoomLevel = this.map.getZoom();
      if(this.taskInfoService.selectedTabName.toLowerCase()===TBTabName.Planned){
        if (this.currentZoomLevel <= 15 && !this.zoomLevelIsLess) {
          this.isZoomLessThanThreshold = true;
  
          this.layerGroup.clearLayers();
          this.setBLMarker(this.blCoordinates);
  
          //replot the routes with different style
          this.plotMarkerOnZoomChange();
          this.zoomLevelIsLess = true;
          this.isAddressMarkersVisible = false;
        }
        else if(this.currentZoomLevel > 15) {
          if(this.zoomLevelIsLess){
          this.isZoomLessThanThreshold = false;
  
          this.layerGroup.clearLayers();
          this.setBLMarker(this.blCoordinates);
          
          //replot the routes with regular view style
          this.plotMarkerOnZoomChange();
          //get the selected view and call the plotting for that view
          this.zoomLevelIsLess = false;
          }
          if (this.isAddressMarkersVisible && this.currentZoomLevel < this.zoomLevelForAddressPtMarker) {
            this.setAddressPtMarkerVisibilityNone();
          }
        }
        if (this.currentZoomLevel >= this.zoomLevelForAddressPtMarker && !this.isAddressMarkersVisible && this.routePtAddressPtMarkers?.length) {
          const key = this.isStopView ? 'stop_id' : 'task_id';
          this.checkAddressMarkerExist(key);
        }
      }
    })
  }

  /**
   * Method creates and sets the business location pin to given coordinate position
   * @param blCoords business location coordinates
   */
  setBLMarker(blCoords: any) {
    let bl: any = this.dataRepositoryService.selectedBusinessLocation;
    this.blName =
      this.dataRepositoryService.businessLocationListMap.get(bl)?.name ?? "";

    let blICon = L.icon({
      iconUrl: "../../../../assets/image/pinbar_Hub.svg",
      iconAnchor: [12, 36],
      popupAnchor: [0, -28],
    });
    this.layerGroup && L.marker([blCoords.latitude, blCoords.longitude], {
      icon: blICon,
    }).addTo(this.layerGroup);


    /**
     * BL popup- below commented block can be used to add information on BL marker
     */
    /**
    let marker = L.marker([blCoords.latitude, blCoords.longitude], {
      icon: blICon,
    }).addTo(this.layerGroup);
    marker
      .bindPopup(
        `<b>Business Location: ${blCoords.latitude}, ${blCoords.longitude}</b>`
      )
      .openPopup(); 
     **/ 
  }

  /**
   * Method initializes the resizeObserver to observe the dimension changes in 
   * Map container element and adjust the center accordingly.
   */
  private observeResize(){
    this.resizeObserver = new ResizeObserver(()=>{
      if(this.map){
        this.map.invalidateSize({ debounceMoveend: true });
      }
    })
    this.mapRef && this.resizeObserver.observe(this.mapRef);
  }


  /**
   * Method sets the map focus and zoom level
   * @param focusCoords coordinate to set the focus on
   * @param zoomLevel zoomlevel of the map
   */
  setMapFocus(focusCoords: any, zoomLevel: number) {
    if (focusCoords) {
      this.map?.setView(
        [focusCoords.latitude, focusCoords.longitude],
        zoomLevel
      );
    }
  }

  setMarkerInclusion(){
    /**
     * Logic to include the marker and update zoom, planned for next release 
     */
    /* while (this.areAllMarkersInView(this.map, this.mapLeafletService.markers)){
      this.currentZoomLevel = this.map.getZoom();
      this.currentZoomLevel += 1;
      this.map.setZoom(this.currentZoomLevel);

    } */
    let isMapZoomFit = this.areAllMarkersInView(
      this.map,
      this.mapLeafletService.markers
    );
    if (!isMapZoomFit) {
      this.currentZoomLevel = this.map.getZoom();
      this.currentZoomLevel -= 1;
      this.map.setZoom(this.currentZoomLevel);
    }
  }

  /**
   * Method check if all the markers are appearing in the map view port
   * @param map map object 
   * @param markers collection of all the plotted task/stop markers
   * @returns boolean value 
   */
  areAllMarkersInView(map: L.Map, markers: L.Layer[]): boolean {
    const bounds = map.getBounds();
    let allInView = true;
  
    markers.forEach((marker:any) => {
      if (!bounds.contains(marker.getLatLng())) {
        allInView = false;
      }
    });
  
    return allInView;
  }

  /**
   * Method calculates the centriod coordinate of all markers plotted on map view.
   * @param markers collection of all the plotted task/stop markers
   * @returns centriod coordinate of all the markers
   */
  getCentroid(markers:L.Marker[]) {
    let coordinates:any = markers.map((marker:any)=>marker.getLatLng())
    if (coordinates.length === 0) {
        return null; // Or handle empty array as needed
    }

    let sumLat = 0;
    let sumLng = 0;

    for (const coord of coordinates) {
        sumLat += coord?.lat;
        sumLng += coord?.lng;
    }

    const meanLat = sumLat / coordinates.length;
    const meanLng = sumLng / coordinates.length;

    return L.latLng(meanLat, meanLng);
  }

  /**
   * Method loads the KPI data
   */
  loadKPIData() {
    try {
      this.loading = true;
      if (this.dataRepositoryService.kpiDataMap.size) {
        this.kpiData = [...this.dataRepositoryService.kpiDataMap.values()];

        //update route selection variables
        if (this.dataRepositoryService.selectedRouteList.length) {
          let routeIDs = this.dataRepositoryService.selectedRouteList.map(
            (route: any) => route.route_id
          );
          this.dataRepositoryService.selectedRouteList = routeIDs?.map(
            (routeId: any) =>
              this.kpiData?.find((k) => k.route_id === routeId) ?? []
          );
          this.selectedKPIRoutes = [
            ...this.dataRepositoryService.selectedRouteList,
          ];
        }
      } else if (
        this.oldSelectedBL != "" &&
        this.newSelectedBL === this.oldSelectedBL
      ) {
        this.dataAccessService.getKPIData();
        this.kpiData = [...this.dataRepositoryService.kpiDataMap.values()];
        this.selectedKPIRoutes = [
          ...this.dataRepositoryService.selectedRouteList,
        ];
      }
      this.loading = false;
      
    } catch (error) {
      if(error instanceof Error){
        this.informUser('KPI loading failed, please reload the page', ErrorType.ERROR)
        this.loading = false;
      }
    }
  }

  /**
   * Method generates the polyline for the input route
   * @param route_id route_id of the input route
   * @param routeData route details of the input route
   * @returns CustomPolylineMarkerType object 
   */
  generatePolylines(
    route_id: string,
    routeData: any[]
  ): CustomPolylineMarkerType {
    let polyline: CustomPolylineMarkerType = {} as CustomPolylineMarkerType;

    let { latitude, longitude } = this.dataRepositoryService.blCoordinates;
    let blCoordinates: any = [latitude, longitude];
    let tasks = this.getTaskCoordinatesFlat(routeData) ?? [];
    let lineCoords = [blCoordinates, ...tasks, blCoordinates];

    let polylineStyle = {
      color: this.dataRepositoryService.routesColour.get(route_id),
      weight: this.isZoomLessThanThreshold ? 1.5 : 3,
      opacity: this.dataRepositoryService.isMapPolylineVisible ? 1.5 : 0,
      smoothFactor: 1,
    };
    polyline = L.polyline(lineCoords, polylineStyle);
    polyline.uniqueID = route_id;
    polyline.parentId = route_id;
    polyline.type = 'polyline';
    return polyline;
  }

  /**
   * Method sets the visibility of polyline based on the user selection,
   * it filters the polyline layers from layerGroup and sets the style 
   */
  togglePolylineVisibility(){
    this.dataRepositoryService.isMapPolylineVisible = !this.dataRepositoryService.isMapPolylineVisible;
    
    // //get all the selected route id
    // let selectedRoutes = this.selectedKPIRoutes;
    // //access all the feature layers
    // let allLayers = this.layerGroup?.getLayers(); 
    // selectedRoutes?.forEach((route:any) => {
    const opacity = this.dataRepositoryService.isMapPolylineVisible ? 1.5 : 0;

    // Toggle polylines in the planned task layerGroup
    const allLayers = this.layerGroup?.getLayers();
    this.selectedKPIRoutes?.forEach((route: any) => {
      allLayers?.forEach((layer: any) => {
        if (layer?.uniqueID && layer?.uniqueID === route.route_id) {
          layer.getLayers()?.forEach((innerLayer: any) => {
            if (
              innerLayer?.uniqueID === route.route_id &&
              innerLayer?.type === 'polyline'
            ) {
              innerLayer.setStyle({ opacity });
            }
          });
        }
      });
    });
    // Toggle polylines in the merged view feature group (planned overlay)
    if (this.isMergedViewVisible) {
      this.mergedViewFG?.getLayers()?.forEach((routeFG: any) => {
        routeFG.getLayers?.()?.forEach((layer: any) => {
          if (layer?.type === 'planned-polyline-merged') {
            layer.setStyle({ opacity: this.dataRepositoryService.isMapPolylineVisible ? 0.5 : 0 });
          }
        });
      });
    }
  }

  /**
   * Method removes the route from the layerGroup object and also GPS marker if any 
   * @param removeRoute route object which is to be removed from layer group
   */
  removeRouteFeatures(removeRoute: any) {
    const uniqueID = removeRoute.route_id;
    const allLayers = this.layerGroup?.getLayers();
    //iterate through all the group routes and remove any layer that belongs to the route
    allLayers?.slice()?.forEach((layer: any) => {
      if (layer?.uniqueID === uniqueID || layer?.parentId === uniqueID) {
        this.layerGroup?.removeLayer(layer);
        return;
      }
      const childLayers = layer?.getLayers?.() ?? [];
      if (childLayers.some((child: any) => child?.uniqueID === uniqueID || child?.parentId === uniqueID)) {
        this.layerGroup?.removeLayer(layer);
      }
    });
    
    //check for route state if On-route then look for the driver marker to remove it
    if (removeRoute.route_state.toLowerCase() === RouteState.Onroute) {
      //check the new GPSFeatureGroup and remove the marker from it
      let gpsMarkerLayers = this.gpsMarkerFG?.getLayers();
      gpsMarkerLayers?.forEach((layer: any) => {
        if (layer?.uniqueID && layer.uniqueID === uniqueID + "DMT") {
          //remove the layer of the identified route
          this.gpsMarkerFG?.removeLayer(layer);

          //remove Map collection entry
          this.gpsDataMap.delete(removeRoute.route_id);
          this.gpsMarkerMap.delete(removeRoute.route_id+"DMT");
        }
      });

      //if all the GPS markers are removed then close the subscription
      if (!this.gpsDataMap.size) {
        this.clearGPSSubscription();
      }
    }

    //clear from the marker collection from map service
    this.mapLeafletService.markers = 
    this.mapLeafletService.markers.filter((f:any)=>f.parentId!==removeRoute.route_id);
  }

  /**
   * Method set the flag when a task marker is clicked from map view, and inform 
   * task bank about the selected task. 
   * @param taskId task id 
   */
  setTaskSelection(taskId: string) {
    let selectedTask: ITasksMap =
      this.dataRepositoryService.plannedTbCollection.get(taskId) ??
      ({} as ITasksMap);
    if (selectedTask) {
      selectedTask.isSelectedByMap = !selectedTask.isSelectedByMap;
      this.addRemoveSelectedTaskOnMap(selectedTask);
    }
  }


  /**
   * Method update the selection/deselection of task marker on map
   * @param selectedTask selected task object 
   */
  addRemoveSelectedTaskOnMap(selectedTask: any) {
    if (selectedTask.isSelectedByMap) {
      this.dataRepositoryService.highlightedTaskOnMap.set(
        selectedTask.task_id,
        selectedTask.task_id
      );
    } else {
      this.dataRepositoryService.highlightedTaskOnMap.delete(
        selectedTask.task_id
      );
    }
    this.dataRepositoryService.plannedTbCollection.set(
      selectedTask.task_id,
      selectedTask
    );
    this.taskInfoService.onSelectCoordinates({
      isSelectedFromMap: selectedTask.isSelectedByMap,
      taskId: selectedTask.task_id,
      routeId: selectedTask.route_id,
    });
  }

  /**
   * Method sets and highlightes the selected task  either from TaskBank row selection or
   * from Map view's task marker click
   * @param taskId task id
   * @param routeId route id
   */
  selectTaskOnMap(taskId: string, routeId?: any) {
    let allLayers = this.layerGroup?.getLayers();
    allLayers?.forEach((routeLayer: any) => {
      if (routeLayer?.uniqueID && routeId && routeLayer?.uniqueID === routeId) {
        let taskLayers = routeLayer?.getLayers();
        if (taskLayers.length) {
          taskLayers.forEach((taskLayer: any) => {
            if (
              taskLayer?.uniqueID &&
              taskLayer?.isSelected != undefined &&
              taskLayer?.uniqueID === taskId &&
              taskLayer?.isSelected === false
            ) {
              taskLayer?.setStyle({
                stroke: true,
                color: "yellow",
              });
              taskLayer.isSelected = true;
            } else if (
              taskLayer?.uniqueID === taskId &&
              taskLayer?.isSelected === true
            ) {
              taskLayer?.setStyle({
                stroke: false,
              });
              taskLayer.isSelected = false;
            }
          });
        }
      }
    });
  }

  /**
   * Method resets the style of input task by removing the highlighted effects
   * @param taskId selected task object
   * @param routeId parent route object of the selected task
   */
  resetHighlightedTask(taskId: string, routeId?: any){
    let allLayers = this.layerGroup?.getLayers();
    allLayers?.forEach((routeLayer: any) => {
      if (routeLayer?.uniqueID && routeId && routeLayer?.uniqueID === routeId) {
        let taskLayers = routeLayer?.getLayers();
        if (taskLayers.length) {
          
          let highlitedTask = taskLayers.find((taskLayer:any)=>taskLayer?.uniqueID === taskId);
          let mapObject:any = this.mapData?.find(f=>f.task_id==taskId)!
          mapObject.isSelectedByMap = false
          
          if(highlitedTask){
            highlitedTask?.setStyle({
              stroke: false,
            });
            highlitedTask.isSelected = false;
          }
        }
      }
    });
    if (this.lastMarkerClickedId?.task_id === taskId) {
      this.hideMarkers();
      this.lastMarkerClickedId = { route_id: null, task_id: null };
    }
  }

  /**
   * Method sets the highlighting effect for the task 
   * @param taskId selected task id
   * @param routeId selected route id
   */
  setHighlightedTask(taskId: string, routeId?:any){
    let allLayers = this.layerGroup?.getLayers();
    if(allLayers.length){
      allLayers?.forEach((routeLayer: any) => {
        if (routeLayer?.uniqueID && routeId && routeLayer?.uniqueID === routeId) {
          let taskLayers = routeLayer?.getLayers();
          if (taskLayers.length) {
            taskLayers.forEach((taskLayer: any) => {
              if (
                taskLayer?.uniqueID &&
                taskLayer?.isSelected != undefined &&
                taskLayer?.uniqueID === taskId &&
                taskLayer?.isSelected === false
              ) {
                taskLayer?.setStyle({
                  stroke: true,
                  color: "yellow",
                });
                taskLayer.isSelected = true;
              }
            });
          }
        }
      });
    }
  }

  /**
   * Method updates the collections about the task selection made 
   * through polygon edit event
   * @param markerInsidePolygon marker object list inside polygon area
   */
  setTaskMovementForPolygonsEdit(markerInsidePolygon:L.Marker[]){
    markerInsidePolygon?.forEach((taskMarker: any) => {
      this.setHighlightedTask(taskMarker.uniqueID, taskMarker.parentId);
      // this.selectTaskOnMap(taskMarker.uniqueID, taskMarker.parentId);
      //update the collection, tb row will higlight globe using this property
      this.dataRepositoryService.plannedTbCollection.set(taskMarker.uniqueID, {
        ...(this.dataRepositoryService.plannedTbCollection.get(
          taskMarker.uniqueID
        ) ?? ({} as ITasksMap)),
        isSelectedByMap: true,
      });
      if(!this.dataRepositoryService.highlightedTaskOnMap.get(taskMarker.uniqueID)){
        this.dataRepositoryService.highlightedTaskOnMap.set(
          taskMarker.uniqueID,
          taskMarker.uniqueID
        );
      }
    });
  }

  /**
   * Method updates the collections about the task removal while polygon 
   * edit or delete event is triggered
   * @param markerOutsidePolygon marker object list inisde polygon area
   */
  setTaskRemoveFromPolygonEdit(markerOutsidePolygon:L.Marker[]){
    let tasks = markerOutsidePolygon.map((m: any) => ({
      task_id: m.uniqueID,
      route_id: m.parentId,
    }));
    tasks.forEach((task) => {
      this.resetHighlightedTask(task.task_id, task.route_id);

      //update the collection, tb row will higlight globe using this property
      if (this.dataRepositoryService.plannedTbCollection.get(task.task_id)) {
        this.dataRepositoryService.plannedTbCollection.set(task.task_id, {
          ...(this.dataRepositoryService.plannedTbCollection.get(
            task.task_id
          ) ?? ({} as ITasksMap)),
          isSelectedByMap: false,
        });
      }
      this.dataRepositoryService.highlightedTaskOnMap.delete(task.task_id);
    });

  }

  /**
   * Method checks the condition for vehicle icon display 
   * if given route is on-route
   * @param routeData route object
   * @returns boolean value to show vehicle icon or not
   */
  showVehicleIconInRouteList(routeData: any) {
    let showIcon: boolean = false;
    //check the route state
    showIcon =
      routeData.route_state.toLowerCase() === RouteState.Onroute &&
      this.selectedKPIRoutes
        ?.map((m) => m.route_id)
        ?.includes(routeData.route_id);

    return showIcon;
  }

  /**
   * Method focuses on driver marker for the given route id
   * @param routeId route id
   */
  focusDriverMarkerOnMap(routeId: string) {
    const driverMarker = this.gpsDataMap.get(routeId);
    const mapViewCenter: Coordinate = {
      latitude: driverMarker?.gps[0].latitude,
      longitude: driverMarker?.gps[0].longitude,
    };
    driverMarker && this.setMapFocus(mapViewCenter, 16);
  }

  /**
   * Method resets the task map, clear all layers 
   * and sets back map to BL marker
   * @param currentZoomLevel current zoom value optional
   */
  resetTaskMap() {
    this.removePolygon();
    this.mergedViewFG?.clearLayers();
    this.layerGroup?.clearLayers();
    this.gpsMarkerFG?.clearLayers();
    this.mapLeafletService.markers = [];
    this.gpsMarkerMap.clear();
    this.plottedRouteList = [];
    this.gpsDataMap.clear();
    this.setBLMarker(this.blCoordinates);
    this.setMapFocus(this.blCoordinates, this.currentZoomLevel ?? 12);
  }

  /**
   * Method performs the plotting of planned task coordinates when 'Task View' option is selected
   * or by default available. It groups all the tasks by routes then plots each route's all task.
   * It also validates GPS case, and lastly focuses the map to the first task point of first route.
   */
  plotPlannedTaskView() {
    if ([...this.dataRepositoryService.selectedRouteList].length > 0) {
      
       const selectedRoutesKpi = [...this.dataRepositoryService.selectedRouteList];
      const selectedRouteIds = new Set(
       selectedRoutesKpi.map((route: any) => route.route_id)
      );
      const plottedRouteIds = new Set(
        this.plottedRouteList.map((route: any) => route.key)
      );
      const tasks = this.mapData.filter((task: any) =>
        selectedRouteIds.has(task.route_id)
      );
      this.groupRoute = this.mapLeafletService.groupCollection(tasks, DataGroupingTypes.RouteID);

      this.groupRoute?.forEach((route: any) => {
         if (plottedRouteIds.has(route.key)) {
          return;
        }
        this.plotPlannedTaskCoordinates(route.values);
      });
      //For the route(s), run the GPS check and API call
      if(this.groupRoute?.length){
        this.checkGPSOnSelectedRoute();
      }
    }
  }

  /**
   * Method plots the task marker for given route, 
   * it creates circle, number and polylines 
   * @param routeTasks tasks object for given route 
   */
  plotPlannedTaskCoordinates(routeTasks: ITasksMap[]) {
    this.polyLineRouteId = routeTasks[0]?.route_id;
    let routeFeatures: CustomFeatureGroupType = L.featureGroup();
    routeFeatures.uniqueID = routeTasks[0]?.route_id;
    routeFeatures.addTo && this.layerGroup && routeFeatures.addTo(this.layerGroup);

    //iterate throught all the task in the route
    routeTasks.forEach((task: any, index: number) => {
      //check if the task has isSelectedByMap property as TRUE in case of delta
      if(this.dataRepositoryService.highlightedTaskOnMap.get(task.task_id)){
        task.isSelectedByMap = true
      }
      //check if the task has task coordintes or else stop coordinate, if none then skip the task and log in console
      if (Boolean(task.task_coordinate) || Boolean(task.coordinate)) {
        //circle
        //call the generator method for circle marker
        let circleMarker: any = this.generateCircleMarker(task);
        /**
         * NOTE ***Commenting below popup generating code - this can be used in future need
         */
        /**
         * popupData = this.getPopupData(task);
         circleMarker.bindPopup(popupData); 
         */
        //add the circleMarker to featureGroup variable
        circleMarker.addTo(routeFeatures);

        //create text inside the circlemarker
        //call the generator method for numbmer marker
        if(!this.isZoomLessThanThreshold){
          let numberMarker: any = this.generateNumberMarker(task);
          //add the numberMarker to the routeFeature
          numberMarker.addTo(routeFeatures);
        }
        if(!this.mapLeafletService.markers.some((marker: any) => marker.uniqueID === circleMarker.uniqueID)){
          this.mapLeafletService.markers.push(circleMarker);
        }
        /**
         * circleMarker.bindPopup(popupData);
         */
      }
    });
    let polyline: any = this.generatePolylines(
      this.polyLineRouteId,
      routeTasks
    );
    polyline.addTo(routeFeatures);

    //register the plotted route in plootedRouteList variable
    this.updatePlottingList();
  }

  /**
   * Method updates the collection of plotted route, order the mapData by routeID
   */
  updatePlottingList(){
    this.plottedRouteList = this.mapLeafletService.groupCollection(
      this.mapData,
      "route_id"
    );
  }

  /**
   * Method create the stop marker for selected routes when 
   * Stop view option is selected 
   */
  plotPlannedStopView() {
    let groupRoute = this.mapLeafletService.groupCollection(this.mapData, DataGroupingTypes.RouteID);
    if (groupRoute.length) {
        const plottedRouteIds = new Set(
        this.plottedRouteList.map((route: any) => route.key)
      );
      groupRoute.forEach((route: any) => {
         if (plottedRouteIds.has(route.key)) {
          return;
        }
        let sortedStopList = this.sortBySequence(
          route.values,
          PlannedSequenceType.StopSequence
        );
        let groupStop = this.mapLeafletService.groupCollection(sortedStopList, DataGroupingTypes.StopID);
        this.plotStopPoints(groupStop);
   //     this.drawStopPolylines(route.key, groupStop);
      });
      this.checkGPSOnSelectedRoute();
    }
  }

  /**
   * Method checks the date, and required route state of GPS API call
   * then initiate GPS marker creation
   * @param selectedRoute option route object which is selected
   */
  checkGPSOnSelectedRoute(selectedRoute?: any){
    if (this.dataRepositoryService.dateOffset === 0) {
      if (selectedRoute) {
        if (selectedRoute?.routeState.toLowerCase() === RouteState.Onroute)
          this.plotGPSMarkers(selectedRoute.routeId);
      }
      else if(this.selectedKPIRoutes.some(s=>s.route_state.toLowerCase()===RouteState.Onroute)){
          this.plotGPSMarkers();
        
      }
    }
  }

  /**
   * Method validates the GPS activation by check date and any exisiting 
   * GPS subscription
   * @returns boolean value
   */
  validateGPSActivation() {
    return (
      this.dataRepositoryService.dateOffset === 0 && [
            ...this.dataRepositoryService.selectedRouteList
          ].length && 
      (this.gpsSubscription?.closed || !this.gpsSubscription)
    );
  }

  /**
   * Method check if a given route is already in GPS route list
   */
  checkGPSActivedRoute(route_id: string) {
    return Boolean(this.gpsDataMap.get(route_id));
  }
  
  //**************Popup**************//
  
  /**
   * Method creates popup for task marker
   * @param markerData task marker data object
   * @returns popup feature on the task marker
   */
  getPopupData(markerData: any) {
    return L.popup({
      content: `<b>Route Name:</b> ${markerData.route_name}
        <br/> <b>Route State:</b> ${markerData.route_state} 
        <br/> <b>Item Count:</b> ${markerData.item_count}
        <br/> <b>Address:</b> ${markerData.address}`,
    }).setLatLng([
      markerData.task_coordinate.latitude,
      markerData.task_coordinate.longitude,
    ]);
  }

  /**
   * Method creates popup for stop marker 
   * @param markerData stop marker data object 
   * @returns popup feature on the stop marker
   */
  getStopPopupData(markerData: any) {
    return L.popup({
      content: `<b>Route Name:</b> ${markerData.route_name}
        <br/> <b>Route State:</b> ${markerData.route_state} 
        <br/> <b>Item Count:</b> ${markerData.item_count}
        <br/> <b>Address:</b> ${markerData.address}`,
    }).setLatLng([
      markerData.stop_coordinate.latitude,
      markerData.stop_coordinate.longitude,
    ]);
  }

  /**
   * Method generates the circle marker from input task data, 
   * adds it to layergroup, sets event listener and returns the marker object 
   * @param markerData task marker data object
   * @returns generated circle marker of customCircleMarkerType class
   */
  generateCircleMarker(markerData: any): customCircleMarkerType {
    //circle
    /**
     * If the task has been completed then color should Green else regular route associated color.
     */
    let circleMarker: customCircleMarkerType = L.circleMarker(
      [
        markerData.task_coordinate?.latitude ?? markerData.coordinate?.latitude,
        markerData.task_coordinate?.longitude ??
          markerData.coordinate?.longitude,
      ],
      {
        radius: this.isZoomLessThanThreshold ? 4 : 8,
        color:
          markerData.task_state.toLowerCase() === TaskState.Completed
            ? "Green"
            : this.dataRepositoryService.routesColour.get(markerData.route_id),
        fillColor:
          markerData.task_state.toLowerCase() === TaskState.Completed
            ? "Green"
            : this.dataRepositoryService.routesColour.get(markerData.route_id),
        fillOpacity: 1.0,
      }
    );

    circleMarker.uniqueID = markerData.task_id ?? "";
    circleMarker.parentId = markerData.route_id ?? "";

    //check highlighting flag
    if (markerData.isSelectedByMap) {
        circleMarker?.setStyle?.({
          stroke: true,
          color: "yellow",
        });
      circleMarker.isSelected = markerData.isSelectedByMap;
    } else {
      circleMarker.isSelected = false;
    }
    circleMarker.addTo && this.layerGroup && circleMarker?.addTo?.(this.layerGroup);
    circleMarker?.addEventListener?.("click", (clickEvent: any) => {
      this.handleMarkerEvent(clickEvent, markerData);
    });
    return circleMarker;
  }

  /**
   * To handle circle marker click event
   * @param clickEvent - event data when user clicks circle marker on Map
   * @param markerData - selected stop/task point data.
  */
  handleMarkerEvent(clickEvent: any, markerData: any) {
    const taskId = clickEvent?.target?.uniqueID;
    const parentId = clickEvent?.target?.parentId;
    this.selectTaskOnMap(taskId, parentId);
    this.setTaskSelection(taskId);
    if (this.currentZoomLevel >= this.zoomLevelForAddressPtMarker) {
      const markerId = markerData.task_id;
      if (this.lastMarkerClickedId?.task_id === markerId) {
        this.hideMarkers();
        this.lastMarkerClickedId = { route_id: null, task_id: null };
      }
      else {
        this.hideMarkers();
        this.drawRoutePoints(markerData);
        this.lastMarkerClickedId = { route_id: markerData.route_id, task_id: markerId };
      }
    }
  }

  /**
   * Creates and return leaftet circle marker with given co-ordinates
  */
  createCircleMarker(lat: any, lng: any, color: string) {
    return (L.circleMarker(
      [lat, lng],
      {
        radius: 10,
        color: color,
        fillColor: color,
        fillOpacity: 1.0,
      }
    ));
  }

  /** Draws route and stop/task points on the map, either by creating new markers or reusing existing.
  * @param markerData - selected stop/task point data.
  */
  drawRoutePoints(markerData: any) {
    let extraCoords, addressCoords, color: any;
    if (markerData.coordinate) {
      addressCoords = markerData.coordinate;
    }
    if (this.isStopView && markerData.task_coordinate) {
      extraCoords = markerData.task_coordinate;
      color = ColorCodesExtraMarker.PINK; //task pt marker - pink
    } else if (this.selectedView === MapViews.TaskView && markerData.stop_coordinate) {
      extraCoords = markerData.stop_coordinate;
      color = ColorCodesExtraMarker.BLUE //stop pt marker - blue
    }

    // Check if Route pt/address pt markers are aalready created. If not create new ones; otherwise, reuse existing markers.
    if (!this.routePtAddressPtMarkers || this.routePtAddressPtMarkers.length !== 2) {
      this.routePtAddressPtMarkers = [];
      this.addAddressPtRoutePtMarkers(addressCoords, ColorCodesExtraMarker.YELLOW, WarningMessage.NOADDRESSPOINTCOORDS);
      this.addAddressPtRoutePtMarkers(extraCoords, color, WarningMessage.NOTASKSTOPCOORDS);
    } else {
      this.setAddressPtMarkerVisibility(0, addressCoords, WarningMessage.NOADDRESSPOINTCOORDS);
      this.setAddressPtMarkerVisibility(1, extraCoords, WarningMessage.NOTASKSTOPCOORDS);
    }
    this.isAddressMarkersVisible = true;
  }

  /**
   * Sets visibility of address and task/stop markers on the map. 
   * @param index - index of marker ( 0 - address pt, 1- task/route pt)
   * @param coordinates - coordinates of marker
   * @param warning - warning message based on type of marker
  */
  setAddressPtMarkerVisibility(index: number, coordinates: any, warning: string) {
    if (coordinates.latitude && coordinates.longitude) {
      this.routePtAddressPtMarkers[index].setLatLng([coordinates.latitude, coordinates.longitude])
        .setStyle({ opacity: 1, fillOpacity: 1 });
      if (!this.layerGroup.hasLayer(this.routePtAddressPtMarkers[index])) {
        this.routePtAddressPtMarkers[index].addTo(this.layerGroup);
      }
    } else {
      this.informUser(warning, ErrorType.WARNING);
    }
  }

  /**
  * Sets visibility to none for address and task/stop markers on the map. 
  */
  setAddressPtMarkerVisibilityNone() {
    if (this.routePtAddressPtMarkers?.length) {
      this.routePtAddressPtMarkers.forEach((marker: any) => {
        if (marker) {
          marker.setLatLng([0, 0]).setStyle({ opacity: 0, fillOpacity: 0 })
        }
      });
    }
    this.isAddressMarkersVisible = false;
  }

  /**
  * Hides all extra markers on the map by setting their styles.
  */
   hideMarkers() {
    this.setAddressPtMarkerVisibilityNone();
    this.routePtAddressPtMarkers = [];
  }

  /**
   * 
   * @param key - task id or stop id
   */
  checkAddressMarkerExist(key: string) {
    if (this.routePtAddressPtMarkers?.length && this.lastMarkerClickedId?.task_id) {
      const taskList = this.mapData.filter((x: any) => x.route_id === this.lastMarkerClickedId?.route_id);
      const exisitingTaskData = taskList?.find((task: any) => task[key] === this.lastMarkerClickedId?.task_id);

      if (exisitingTaskData) {
        if (this.currentZoomLevel >= this.zoomLevelForAddressPtMarker) {
          this.drawRoutePoints(exisitingTaskData);
        }
      } else {
        this.hideMarkers();
      }
    }
  }

  /**
  * Creates and adds a circle marker to the map if the given coordinates are valid. shows appropriate warning if coordinates are missing.
  * @param coords - Latitude and longitude for the marker.
  * @param color - Color code to be used for the marker based on type.
  * @param warningMessage - warning message based on the marker type
  */
  addAddressPtRoutePtMarkers(coords: any, color: string, warningMessage: string) {
    if (coords?.latitude && coords?.longitude) { //address pt marker - yellow
      const marker = this.createCircleMarker(coords.latitude, coords.longitude, color);
      this.routePtAddressPtMarkers.push(marker);
      marker.addTo(this.layerGroup);
    } else {
      this.informUser(warningMessage, ErrorType.WARNING)
    }
  }

  /**
   * Method generates the number marker from input task data, 
   * adds it to layergroup, sets event listener and returns the number marker object 
   * @param numberData task marker data object
   * @returns generated number marker of CustomMarkerType class
   */
  generateNumberMarker(numberData: any): CustomMarkerType {
    //create text inside the circlemarker

    let strokeColor = "yellow";
    let textColor = "#FFFFFF";
    let textStyle;
    let textMargin = "0vh";
    if (numberData.task_sequence?.toString().length == 2) {
      textMargin = "-17%";
    } else if (numberData.task_sequence?.toString().length == 3) {
      textMargin = "-45%";
    } else if (numberData.task_sequence?.toString().length == 4) {
      textMargin = "-86%";
    }
    if (numberData.task_state.toLowerCase() === TaskState.Completed) {
      textStyle = `text-align:center; font-weight:bold; stroke: ${strokeColor}; color: ${textColor}; margin-left: ${textMargin}`;
    } else {
      textStyle = `text-align:center; font-weight:bold; color: ${textColor}; margin-left: ${textMargin}`;
    }
    let textIcon = L.divIcon({
      className: "text-label numberStyle",
      html: `<div style="${textStyle}">${numberData.task_sequence}</div>`,
      iconSize: [10, 10],
      iconAnchor: [5, 10],
    });

    let numberMarker: CustomMarkerType = L.marker(
      [
        numberData.task_coordinate?.latitude ?? numberData.coordinate?.latitude,
        numberData.task_coordinate?.longitude ??
          numberData.coordinate?.longitude,
      ],
      { icon: textIcon }
    );
    numberMarker.uniqueID = numberData.task_id;
    numberMarker.parentId = numberData.route_id;
    this.layerGroup && numberMarker?.addTo?.(this.layerGroup);
    numberMarker?.addEventListener?.("click", (event: any) => {
      this.handleMarkerEvent(event, numberData)
    });

    return numberMarker;
  }

  /**
   * Method updates the collection with new delta updates
   * @param deltaUpdates delta updates 
   */
  updateDeltaChanges(deltaUpdate: PlannedSubscriptionData) {
    //grouping is required, because tasks array is mixed of multiple routes with random order
    let deltaRoutes = this.mapLeafletService.groupCollection(deltaUpdate.deltaUpdates, DataGroupingTypes.RouteID);

    let allLayers = this.layerGroup?.getLayers();
    //iterate through all the group routes
    deltaRoutes?.forEach((deltaRoute: any) => {
      //test accessing  the layer of each route
      allLayers?.forEach((layer: any) => {
        if (
          layer?.uniqueID &&
          layer.uniqueID == deltaRoute.values[0].route_id
        ) {
          //remove the layer of the identified route
          this.layerGroup?.removeLayer(layer);
          //clear from the marker collection from map service
          this.mapLeafletService.markers = this.mapLeafletService.markers.filter(
            (f: any) => f.parentId !== deltaRoute.values[0].route_id
          );
          //replot the layer of the identified route as same as route selection
          this.groupRoutes(deltaRoute.values[0].route_id, true);
        }
      });
    });


    const affectedRouteIds = new Set<string>(
      deltaRoutes?.map((deltaRoute: any) => deltaRoute.values[0].route_id) ?? []
    );

    // Handle removed tasks: only replot route layers that contain those removed task ids.
    if (deltaUpdate.removedTasks?.length) {
      const removedTaskIds = new Set(deltaUpdate.removedTasks);
      allLayers?.forEach((layer: any) => {
        const routeId = layer?.uniqueID;
        const routeLayers = layer?.getLayers?.();
        if (!routeId || !routeLayers?.length) {
          return;
        }
         const hasRemovedTask = routeLayers.some((routeLayer: any) => routeLayer?.uniqueID && removedTaskIds.has(routeLayer.uniqueID));
        if (!hasRemovedTask) {
          return;
        }
        this.layerGroup?.removeLayer(layer);
        this.mapLeafletService.markers = this.mapLeafletService.markers.filter(
          (f: any) => f.parentId !== routeId
        );
        this.groupRoutes(routeId, true);
        affectedRouteIds.add(routeId);
      });
    }

    //polygon update on delta
    if(this.drawnPolygonMap.size){
     affectedRouteIds.forEach((routeId: string) => {
        this.updatePolygonWithDelta(routeId)
      });
    }

  }

  /**
   * Method extracts the polygons having input route id and update the polygon
   * with delta changes
   * @param routeId route id in delta update
   */
  updatePolygonWithDelta(routeId?: string){
    //get all the polygons
    let polygonLayers:any = [...this.drawnPolygonMap.values()];
    let extractedPolygons = [];
    if(routeId){
      extractedPolygons = polygonLayers.filter((f:any)=>f?.groupRoutes?.includes(routeId));
    }
    else{
      extractedPolygons = polygonLayers;
    }

    //iterate through polygon and check 
    extractedPolygons?.forEach((polygon:any) => {
      this.updatePolygon(polygon, true);
    });
  }

  /*****UNCOMMENT BELOW CODE BLOCK FOR PHASE-2 RELEASE */
  /* generateDriverMaker(routeData: any) {
    let circleMarker: customCircleMarkerType = L.circleMarker(
      [routeData.gps[0].latitude, routeData.gps[0].longitude],
      {
        radius: 20,
        color: this.dataRepositoryService.routesColour.get(routeData.route_id),
        fillColor: this.dataRepositoryService.routesColour.get(
          routeData.route_id
        ),
        fillOpacity: 1.0,
      }
    );
    circleMarker.setStyle &&
      circleMarker.setStyle({
        stroke: true,
        color: "yellow",
      });
    circleMarker.uniqueID = routeData.route_id+"DM";
    circleMarker.addTo && circleMarker.addTo(this.layerGroup);
    circleMarker.addEventListener &&
      circleMarker.addEventListener("click", (_event: any) => {
        //perform the activity with driver marker click action
      });

    return circleMarker;
  } */

  /**
   * Method gets GPS coordinates from API and plots the driver marker  
   * @param route_id route id 
   */
  plotGPSMarkers(route_id?: string) {
    this.getGPSData(route_id)
      .pipe(take(1),takeUntilDestroyed(this.#destroyRef))
      .subscribe({
        next: (gpsRoutes: any) => {

          //iterate through all the routes in the response and generate marker for each one.
          gpsRoutes.forEach((gpsroute: GPSResponse) => {
            const GPSResponseData = [
              {
                latitude: gpsroute.coordinate.latitude,
                longitude: gpsroute.coordinate.longitude,
              },
            ];
            const routeObject = {
              route_id: gpsroute.route_id,
              gps: GPSResponseData,
            };

            this.gpsDataMap.set(gpsroute.route_id, routeObject);
            /**
             * Generate the driver marker as layer
             */
            /* const driverMarker: any = this.generateDriverMaker(routeObject); */

            //add to featureGroup
            // driverMarker.addTo(routeFeatures);
            // const driverTextMarker: any =
            this.generateDriverMarkerText(routeObject);
            // driverTextMarker.addTo(routeFeatures);
          });
        },
        error: (err: any) => {},
        complete() {},
      });
  }

  /**
   * Method generates the driver marker, sets its text, adds it to layer group and 
   * returns the generates marker object
   * @param routeData route data object
   * @returns driver marker object
   */
  generateDriverMarkerText(routeData: any) {
    let color = this.dataRepositoryService.routesColour.get(routeData.route_id);

    let textIcon1 = L.divIcon({
      className: "image-icon",
      html: `<svg width="40px" height="35px" viewBox="38 12 128 180" >
              <path style="fill:${color};stroke:#FFFF00;stroke-width:7;stroke-miterlimit:10;" d="M158.5,73.8c0-32.3-26.2-58.4-58.4-58.4c-32.3,0-58.4,26.2-58.4,58.4c0,16.6,6.9,31.5,18,42.1c7.2,7.2,16.7,17.2,20.1,22.5c7,10.9,20,47.9,20,47.9s13.3-37,20.4-47.9c3.3-5.1,12.2-14.4,19.3-21.6C151.2,106.1,158.5,90.9,158.5,73.8z"/>
              <image href="../../../../assets/image/truckIcon.svg" x="40" y="20" height="100px" width="100px" />
             </svg>`,
      iconAnchor: [12, 36],
    });

    let driverTextMarker: CustomMarkerType = L.marker(
      [routeData.gps[0].latitude, routeData.gps[0].longitude],
      { icon: textIcon1 }
    );
    driverTextMarker.uniqueID = routeData.route_id + "DMT";
    if(!this.gpsMarkerMap.get(driverTextMarker.uniqueID)){
      this.gpsMarkerMap.set(driverTextMarker.uniqueID, driverTextMarker);
      driverTextMarker.addTo && driverTextMarker?.addTo?.(this.gpsMarkerFG);
    }
  }

  /**
   * Method call GPS data of route id and formats the reponse 
   * and return the formatted response as an observable 
   * @param route_id route id
   * @returns observables of GPS reponse
   */
  getGPSData(route_id?: string) {
    //get all the selected route and filter on-routes
    let gpsResponse$ = new Subject<GPSResponse[]>();
    let formattedGPSResponse: GPSResponse[] = [];
    let onRouteIds;
    //check if parameter of route_id param is available, then call GPS or get all on-route GPS values
    if (!route_id) {
      onRouteIds = this.selectedKPIRoutes
        .filter(
          (route) => route.route_state.toLowerCase() === RouteState.Onroute
        )
        .map((m) => m.route_id)
        .toString();
    } else {
      onRouteIds = route_id;
    }
    if(onRouteIds){
      this.getGPS(onRouteIds)
        .pipe(take(1))
        .subscribe({
          next: (gpsResponse: any) => {
            formattedGPSResponse = this.formatGPSResponse(gpsResponse.gps);
          },
          error: (error) => {},
          complete: () => {
            if (formattedGPSResponse.length) {
              gpsResponse$.next(formattedGPSResponse);
              gpsResponse$.complete();
            }
            if (
              this.dataRepositoryService.dateOffset === 0 &&
              (this.gpsSubscription?.closed || !this.gpsSubscription)
            ) {
              this.getGPSDelta();
            }
          },
        });
    }
    return gpsResponse$.asObservable();
  }

  /**
   * Method calls GPS API for route id and return the reponse as
   * an observable 
   * @param routeIds route id
   * @returns HTTPS request's response as an observable
   */
  getGPS(routeIds: string) {
    let queryParams = {
      routeIds: routeIds,
    };
    return this.connectionService.httpReq({
      reqType: AppConstants.GETREQUEST,
      endUrl: AppConstants.GPS,
      directoryType: AppConstants.DP,
      data: queryParams,
      isLoader: false
    });
  }

  /**
   * Method formats the GPS API response into GPSResponse Class type
   * @param gpsResponse GPS API response
   * @returns formatted GPS data
   */
  formatGPSResponse(gpsResponse: GPSResponse[]): GPSResponse[] {
    let gpsData: GPSResponse[] = [];
    gpsResponse.forEach((gpsRoute: GPSResponse) => {
      let gpsObject: GPSResponse = { ...gpsRoute };

      /**
       * DESTRUCTRRED version of object
      let gpsObject: GPSResponse = {
        route_id: gpsRoute.route_id,
        coordinates: gpsRoute.coordinates,
        accuracy: gpsRoute.accuracy,
        timestamp: gpsRoute.timestamp,
        speed: gpsRoute.speed,
        heading: gpsRoute.heading,
      };
       */
      gpsData.push(gpsObject);
    });
    return gpsData;
  }

  /**
   * Method handles the delta call for GPS API with 1 min interval 
   */
  getGPSDelta() {
    this.gpsSubscription = interval(IntervalDuration.GPSDELTA)
      .pipe(
        takeWhile((v) => this.dataRepositoryService.dateOffset === 0 && this.selectedKPIRoutes.some(s=>s.route_state.toLowerCase()===RouteState.Onroute)),
        mergeMap(() =>
          this.getGPS(
            this.selectedKPIRoutes
              .filter(
                (route) =>
                  route.route_state.toLowerCase() === RouteState.Onroute
              )
              .map((m) => m.route_id)
              .toString()
          )
        )
      )
      .subscribe({
        next: (response: any) => {
          this.processGPSDelta(response);
        },
      });
    this.subscription.push(this.gpsSubscription);
  }

  /**
   * Method update the collection and plotting with new delta information 
   * on GPS API
   * @param gpsDeltaResponse delta response object from GPS API
   */
  processGPSDelta(gpsDeltaResponse: any) {

    //iterate through all the group routes
    
    gpsDeltaResponse?.gps?.forEach((gpsRoute: any) => {
      this.ngZone.run(()=>{
        let gpsMarkerLayers = this.gpsMarkerFG?.getLayers();
        gpsMarkerLayers?.forEach((layer: any) => {
          if (layer?.uniqueID && layer.uniqueID == gpsRoute.route_id + "DMT") {
            layer.setLatLng([
              gpsRoute.coordinate.latitude,
              gpsRoute.coordinate.longitude,
            ]);
          }
        });
      });
    })
  }

  /**
   * Method forms the task coordinate array from a route object
   * @param groupRoute route data object
   * @returns task coordinate array
   */
  getTaskCoordinatesFlat(groupRoute: any[]): [number, number][] {
    let taskCoordinates: [number, number][] = [];
    groupRoute.flatMap((task) => {
      if (task.task_coordinate || Boolean(task.coordinate)) {
        taskCoordinates.push([
          task.task_coordinate?.latitude ?? task.coordinate?.latitude,
          task.task_coordinate?.longitude ?? task.coordinate?.longitude,
        ]);
      }
    });
    return taskCoordinates;
  }

    /**
   * In merged view polygon only include the active tab's markers.
   */
  private filterForMergedView(markers: L.Marker[]): L.Marker[] {
    if (
      !this.isMergedViewVisible ||
      this.taskInfoService.selectedTabName.toLowerCase() === TBTabName.Planned.toLowerCase()
    ) {
      return markers;
    }

    return markers.filter(
      (m: any) => !this.dataRepositoryService.plannedTbCollection.has(m.uniqueID)
    );
  }


  /**
   * Handles route selection and deselection from the route table.
   */
  routeSelect(selectedRoutes: Routes[]) {
    selectedRoutes = selectedRoutes.filter((value: any) => {
      return value.route_id != null;
    });
    const isPlannedTabActive =
      this.taskInfoService.selectedTabName.toLowerCase() ===
      TBTabName.Planned.toLowerCase();

    if (selectedRoutes?.length) {
      const previousSelectedRoutes = [...this.selectedKPIRoutes];
      const previousRouteIds = new Set(
        previousSelectedRoutes.map((r: any) => r.route_id)
      );

      const newRoutes = selectedRoutes.filter((r: any) => !previousRouteIds.has(r.route_id));
      const removedCount = previousSelectedRoutes.length -
        selectedRoutes.filter((r: any) => previousRouteIds.has(r.route_id)).length;

      this.dataRepositoryService.selectedRouteList = selectedRoutes;

      // ── DESELECT path ────────────────────────────────────────────────────────
      if (removedCount > 0) {
        this.selectedKPIRoutes = [...selectedRoutes];
        this.handleDeselectedRoute(selectedRoutes, previousSelectedRoutes);
        // Close GPS subscription when no on-route routes remain.
        if (this.selectedKPIRoutes.every(
          (e) => e.route_state.toLowerCase() !== RouteState.Onroute
        )) {
          this.clearGPSSubscription();
        }
      }

      // ── SELECT path ──────────────────────────────────────────────────────────
      if (newRoutes.length > 0) {
        this.selectedKPIRoutes = [...selectedRoutes];

        this.taskInfoService.isViewChangedToPlanned = true;
        // Ensure Planned tab is active if not already and merged view is not visible
        if (!isPlannedTabActive && !this.isMergedViewVisible) {
          this.taskInfoService.ensurePlannedTabActive();
        }

        this.map.setZoom(this.currentZoomLevel <= 12 ? this.currentZoomLevel : 12);
        this.selectedView = MapViews.TaskView;

        this.taskInfoService.kpiSelectionDisabled = true;
        this.taskInfoService.isBulkProcessing = true;

        const latestRoute = newRoutes.at(-1);
        this.lastSelectedRoute = {
          isChecked: true,
          routeId: latestRoute?.route_id,
          routeState: latestRoute?.route_state,
        };
        this.dataAccessService.currentSelectedRoute.next({
          isChecked: true,
          routeId: latestRoute?.route_id,
          routeState: latestRoute?.route_state,
        });
        this.taskInfoService.getPlannedDataBulk(newRoutes);
      }
      this.setMapControlButtonVisibility();
    } else {
      // All routes deselected via Reset
      this.dataRepositoryService.selectedRouteList = [];
      this.deselectAll();
      this.mapData = [];
      this.plottedRouteList = [];
      this.selectedKPIRoutes = [];
      this.setMapControlButtonVisibility();
    }
  }

  /**
   * Method handles the deselection of the route, updates the collections.
   * It compares the previous selectedKPI routes with new available routes
   * and removed the unmatched routes as deselected.
   * @param selectedRoutes clicked/available routes     
   */
  handleDeselectedRoute(selectedRoutes: any, previousSelectedRoutes: any[] = this.selectedKPIRoutes) {
    previousSelectedRoutes.forEach((route: any) => {
      const deselectedRoute = selectedRoutes.find(
        (routes: any) => routes.route_id === route.route_id
      );
      if (deselectedRoute == undefined) {
        this.lastSelectedRoute = {
          isChecked: false,
          routeId: route.route_id,
          routeState: route.route_state,
        };
        this.removeDeselectedRoute(this.lastSelectedRoute);
        this.taskInfoService.removeDeselectedRoute(route.route_id);
        this.dataAccessService.currentSelectedRoute.next(this.lastSelectedRoute);
        if(this.lastSelectedRoute.routeId === this.lastMarkerClickedId?.route_id) {
          this.hideMarkers();
        }
      }
    });
    if (!selectedRoutes.length) {
      this.isMergedViewVisible = false;
      this.mergedViewFG?.clearLayers();
    } else if (this.isMergedViewVisible && this.isMergedViewSupportedTab()) {
      this.plotMergedView();
    }
    this.setMapControlButtonVisibility();
   this.taskInfoService.updatePlannedTabCount()
  }

  // When user clicks on Reset button, all the select routes should be deselected, update the same in task bank and summary,
  deselectAll() {
    const routesToDeselect = [...this.selectedKPIRoutes];
    const routeIds = routesToDeselect.map((route: any) => route.route_id);
    const routeIdSet = new Set(routeIds);
    const isPlannedTabActive =
      this.taskInfoService.selectedTabName.toLowerCase() === TBTabName.Planned.toLowerCase();

    this.dataRepositoryService.selectedRouteList = [];
    this.lastSelectedRoute = {};
    this.taskMovementService.selectedOptionsForTaskMove = [];
    this.taskMovementService.taskmoveCount.set(this.taskMovementService.selectedOptionsForTaskMove.length);

    this.selectedKPIRoutes = [];
    this.dataRepositoryService.highlightedTaskOnMap.clear();
    this.dataAccessService.currentSelectedRoute.next({
      isChecked: false,
      routeId: null,
      routeState: null,
    });

    if (routeIdSet.has(this.lastMarkerClickedId?.route_id)) {
      this.hideMarkers();
    }

    // Planned tab wipes the whole map via resetTaskMap(); other tabs keep their
    // own task markers, so strip only the deselected routes' layers in one pass.
    if (!isPlannedTabActive) {
      this.removeDeselectedRoutesFeatures(routeIdSet);
    }
    this.taskInfoService.resetAllRoutes(routeIds);

    //reset the map and show the hub marker
    this.mapLeafletService.markers = [];
    if (isPlannedTabActive) {
      this.resetTaskMap();
    }
    this.clearRoutesColorMap();
    this.clearGPSSubscription();
    this.isMergedViewVisible = false;
    this.mergedViewFG?.clearLayers();
    this.setMapControlButtonVisibility();
  }

  /**
   * Batch map cleanup for a full Reset: removes every deselected route's plotted
   * layers and driver markers in a single pass per collection instead of once per
   * route. Other-task markers (keyed by task/item id, not route id) are left
   * intact, matching the per-route removeRouteFeatures behavior. The shared
   * marker list and GPS subscription are cleared by the caller (deselectAll).
   */
  private removeDeselectedRoutesFeatures(routeIdSet: Set<string>): void {
    this.plottedRouteList = this.plottedRouteList.filter(
      (route: any) => !routeIdSet.has(route.key)
    );

    this.layerGroup?.getLayers()?.slice()?.forEach((layer: any) => {
      if (routeIdSet.has(layer?.uniqueID) || routeIdSet.has(layer?.parentId)) {
        this.layerGroup?.removeLayer(layer);
        return;
      }
      const childLayers = layer?.getLayers?.() ?? [];
      if (childLayers.some((child: any) => routeIdSet.has(child?.uniqueID) || routeIdSet.has(child?.parentId))) {
        this.layerGroup?.removeLayer(layer);
      }
    });

    this.gpsMarkerFG?.clearLayers();
    this.gpsDataMap.clear();
    this.gpsMarkerMap.clear();
  }

  /**
   * Method handles removal of the route 
   * @param clickedRoute route to be removed
   */
  removeDeselectedRoute(clickedRoute: any): void {
    const routeObj = { ...clickedRoute };
    if (routeObj.routeId) {
      //remove the plotted task from the map
      const removeRoute = {
        route_id: routeObj.routeId,
        route_state: routeObj.routeState,
        isChecked: routeObj.isChecked,
      };
      //update the count of plotted route list 
      this.plottedRouteList = this.plottedRouteList.filter(
        (route: any) => route.key !== removeRoute.route_id
      );
      this.removeRouteFeatures(removeRoute);
    }
  }

  /**
   * Method checks if highlighting effects if required for existing plotted route,
   * delta changes may removed an existing highlighted marker so its entry 
   * should be removed from repo.
   */
  updateHighlightedTaskList(){
    let removedHighlights: string[] = [];
    const allTaskIds: string[] = this.mapData?.map((m) => m.task_id);
    this.dataRepositoryService.highlightedTaskOnMap.forEach(
      (highlightedTask: any) => {
        if (!allTaskIds.some((taskId) => taskId == highlightedTask)) {
          removedHighlights.push(highlightedTask);
        }
      }
    );
    removedHighlights.forEach((rmTask) => {
      this.dataRepositoryService.highlightedTaskOnMap.delete(rmTask);
    });
  }

  /**
   * Method resets the components variables and collections
   */
  resetComponentVariables() {
    this.selectedKPIRoutes = [];
    this.dataRepositoryService.selectedRouteList = [];
    this.oldSelectedBL = this.newSelectedBL != "" ? this.newSelectedBL : "";
    this.gpsDataMap.clear();
    this.gpsMarkerMap.clear();
    this.dataRepositoryService.highlightedTaskOnMap.clear();

  }

  /**
   * Method begins the plotting of the route based on the selected 
   * view options
   * @param routeId route id
   * @param deltaUpdates boolean value TRUE for delta calls  
   */
  groupRoutes(routeId?: string, deltaUpdates?: any) {
    //vehicle icon in route list
    const kpiRoute = this.kpiData.find((f) => f.route_id === routeId);
    this.showVehicleIconInRouteList(kpiRoute);
    let selectRouteTaskList: any = this.mapData;
    if (routeId) {
      selectRouteTaskList = selectRouteTaskList.filter(
        (x: any) => x.route_id === routeId
      );
    }
    if (selectRouteTaskList.length) {
      if (!this.isStopView) {
        selectRouteTaskList = this.sortBySequence(
          selectRouteTaskList,
          PlannedSequenceType.TaskSequence
        );
        this.plotPlannedTaskCoordinates(selectRouteTaskList);
        this.checkAddressMarkerExist('task_id');
        this.dataRepositoryService.selectedRouteList = this.selectedKPIRoutes;
      } else {
        let sortedStopList = this.sortBySequence(
          selectRouteTaskList,
          PlannedSequenceType.StopSequence
        );
        let groupStop = this.mapLeafletService.groupCollection(sortedStopList, DataGroupingTypes.StopID);
        this.plotStopPoints(groupStop);
        this.checkAddressMarkerExist('stop_id');
        this.drawStopPolylines(routeId!, groupStop);

      }

      //update the collection of plotted route, order the mapData by routeID
      this.updatePlottingList();
    }
  }

  /**
   * Method clears the route colors Map collection
   */
  clearRoutesColorMap() {
    this.dataRepositoryService.routesColour?.clear();
  }

  /**
   * Method unsubsscribes the existing GPS subscription
   */
  clearGPSSubscription() {
    if (
      this.dataRepositoryService.dateOffset === 0 &&
      Boolean(this.gpsSubscription)
    ) {
      this.gpsSubscription.unsubscribe();
    }
  }

  /**
   * Method get the last selected route and calls 
   * other method for plotting the route
   * @param routes route list
   */
  plotAllRoutes(routes: any[]) {
    routes.forEach((route) => {
      this.groupRoutes(route?.route_id);
    });
  }

  /**
   * Method gets the task/stop for selected routes and plots the markers
   * based on the set zoom constraint. Small circles in lower zoom and
   * circle with number in higher zoom
   */
  plotMarkerOnZoomChange(){
    let selectRouteTaskList: any;
    this.selectedKPIRoutes?.forEach((selectedRoute) => {
      if (selectedRoute.route_id) {
        selectRouteTaskList = this.mapData.filter(
          (x: any) => x.route_id === selectedRoute.route_id
        );
      }
      const gpsData = this.gpsDataMap.get(selectedRoute.route_id)
      if(gpsData) {
        this.generateDriverMarkerText(gpsData)
      }
      if (selectRouteTaskList.length) {
        if (!this.isStopView) {
          selectRouteTaskList = this.sortBySequence(
            selectRouteTaskList,
            PlannedSequenceType.TaskSequence
          );
          this.plotPlannedTaskCoordinates(selectRouteTaskList);
          this.dataRepositoryService.selectedRouteList = this.selectedKPIRoutes;
        } else {
          let sorteStopList = this.sortBySequence(
            selectRouteTaskList,
            PlannedSequenceType.StopSequence
          );
          let groupStop = this.mapLeafletService.groupCollection(
            sorteStopList,
            "stop_id"
          );
          this.plotStopPoints(groupStop);
        }
      }
    });
  }

  /**
   * Method performs the plotting of stop marker when stop view is selected
   * @param stopData stops information
   */
  plotStopPoints(stopData: any) {
    let routeFeatures: CustomFeatureGroupType = L.featureGroup();
    routeFeatures.uniqueID = stopData[0].values[0]?.route_id;
    routeFeatures.addTo && routeFeatures?.addTo?.(this.layerGroup);

    stopData.forEach((stop: any, index: number) => {
      let stop_info = stop.values[0];
      //circle
      if (Boolean(stop_info.stop_coordinate) || Boolean(stop_info.coordinate)) {
        let stopCircleMarker: any = this.generateStopCircleMarker(stop_info);
        /* popupData = this.getStopPopupData(stop_info);
        stopCircleMarker.bindPopup(popupData); */
        //add the circleMarker to featureGroup variable
        stopCircleMarker.addTo(routeFeatures);

        //create text inside the circlemarker
        //call the generator method for numbmer marker
        if(!this.isZoomLessThanThreshold){
          let stopNumberMarker: any = this.generateStopNumberMarker(stop_info);
          //add the numberMarker to the routeFeature
          stopNumberMarker.addTo(routeFeatures);
        }
        /* stopNumberMarker.bindPopup(popupData); */
      }
    });
    let routeId = stopData[0].values[0]?.route_id;
    let polyline: any = this.drawStopPolylines(routeId,stopData);
    polyline.addTo(routeFeatures);
  }

  /**
   * Method creates the polyline for stop view 
   * @param route_id route id
   * @param stopData stop coordinate data list 
   */
  drawStopPolylines(route_id: string, stopData: any[]) {
    let blCoords = this.dataRepositoryService.blCoordinates;
    let stopView = this.getStopCoordinatesFlat(stopData);
    let lineCoords: any = this.isStopView
      ? [
          [blCoords.latitude, blCoords.longitude],
          ...stopView,
          [blCoords.latitude, blCoords.longitude],
        ]
      : stopView ?? [];
    let polyline: any = L.polyline(lineCoords, {
      color: this.dataRepositoryService.routesColour.get(route_id),
      weight: 3,
      opacity: this.dataRepositoryService.isMapPolylineVisible ? 1.5 : 0,
      smoothFactor: 1,
    });
    polyline.uniqueID = route_id; 
    polyline.parentId = route_id;
    polyline.type = 'polyline';
    return polyline;
  }

  /**
   * Method generates the stop coordinate array object from 
   * input route 
   * @param groupRoute route list object
   * @returns stop coordinates collection
   */
  getStopCoordinatesFlat(groupRoute: any[]): [number, number][] {
    let stopCoordinates: [number, number][] = [];
    groupRoute.flatMap((stop: any) => {
      let stop_id = stop.key;
      let stop_info = stop.values[0];
      if (Boolean(stop_info.stop_coordinate) || Boolean(stop_info.coordinate)) {
        stopCoordinates.push([
          stop_info.stop_coordinate?.latitude ?? stop_info.coordinate?.latitude,
          stop_info.stop_coordinate?.longitude ??
            stop_info.coordinate?.longitude,
        ]);
      }
    });
    return stopCoordinates;
  }

  /**
   * Method checks the active TB tab and process API calls 
   * and map plotting
   */
  checkActiveTabForPlotting(){
    switch (this.taskInfoService.selectedTabName.toLowerCase()) {
      case TBTabName.Planned.toLowerCase():
        if (this.mapData.length) {
          this.plotPlannedTaskView();
          this.selectedView = MapViews.TaskView;
        }
        this.taskInfoService.activeTabSubscription();
        break;
      case TBTabName.Unplannedpickup.toLowerCase():
      case TBTabName.PlannedPBM.toLowerCase():
      case TBTabName.Unloaded.toLowerCase():
      case TBTabName.PushToCloud.toLowerCase():
        this.taskInfoService.activeTabSubscription();
        break;
    }
  }

  /**
   * Spike on Plotting Task/Stop without Route information
   * To show Unplanned/unloaded type of task on Map
   */
  plotOtherTasks(tasks: any, deltaUpdates?: any) {
    //create the feature froup - all the tasks belonging to a TB tab come in one feature group

    if (tasks.length) {
      let otherTasksFeaturesGroup: CustomFeatureGroupType = L.featureGroup();
      /**
       * Unique ID 'OtherTaskFeatureGroupUniqueID' (OTFGUID) for feature grouping of
       * other type of task shall be reformed in future release of PI-2. 
       */
      otherTasksFeaturesGroup.uniqueID = "OTFGUID";
      this.layerGroup && otherTasksFeaturesGroup?.addTo?.(this.layerGroup);

      if(this.layerGroup){
        const existingLayers = this.layerGroup.getLayers();
        const duplicateCircleIds = new Set(
          existingLayers
            .filter((layer: any) => layer?.uniqueID && layer?.type === 'circle-marker')
            .map((layer: any) => layer.uniqueID)
        );
        const duplicateNumberIds = new Set<any>();
        existingLayers.forEach((layer: any) => {
          if (layer?.uniqueID === 'OTFGUID') {
            layer.getLayers?.().forEach((childLayer: any) => {
              if (childLayer?.uniqueID && childLayer?.type === 'number-marker') {
                duplicateNumberIds.add(childLayer.uniqueID);
              }
            });
          }
        });
        const mapMarkerIds = new Set(
          this.mapLeafletService.markers.map((marker: any) => marker.uniqueID)
        );

        //iterate throught all the task in the route
        tasks.forEach((task: any, index: number) => {
          //check if the task has task coordintes or else stop coordinate, if none then skip the task and log in console
          if (Boolean(task.task_coordinate) || Boolean(task.stop_coordinate)|| Boolean(task.coordinate)) {
            //circle
            //call the generator method for circle marker
            let circleMarker: any = this.generateOtherTaskCircleMarker(task);
            if (circleMarker.uniqueID && circleMarker.type) {
              duplicateCircleIds.add(circleMarker.uniqueID);
            }
            //add the circleMarker to featureGroup variable
            if (!(circleMarker.uniqueID && circleMarker.type && duplicateCircleIds.has(circleMarker.uniqueID))) {
              circleMarker.addTo(otherTasksFeaturesGroup);
            }
            
            //create text inside the circlemarker
            //call the generator method for numbmer marker
            let numberMarker: any = this.generateOtherTaskNumberMarker(task, index+1);
            //add the numberMarker to the routeFeature
            if (!(numberMarker.uniqueID && numberMarker.type && duplicateNumberIds.has(numberMarker.uniqueID))) {
              numberMarker.addTo(otherTasksFeaturesGroup);
              if (numberMarker.uniqueID && numberMarker.type) {
                duplicateNumberIds.add(numberMarker.uniqueID);
              }
            }

            if(!mapMarkerIds.has(circleMarker.uniqueID)){
              this.mapLeafletService.markers.push(circleMarker);
              mapMarkerIds.add(circleMarker.uniqueID);
            }
          }
        });

        //reCalculate polygon collection 
        if(deltaUpdates?.isDeltaUpdate && deltaUpdates?.deltaTasks?.length){
          if(this.drawnPolygonMap.size){
            this.updatePolygonWithDelta();
          }
        }
      }
    }
  }

  /**
   * Method checks if the generated circle marker is duplicate or not 
   * @param marker circle marker object 
   * @returns boolean value
   */
  checkDuplicateCircleMarker(marker:customCircleMarkerType){
    let isDuplicate = false;
    let allLayers = this.layerGroup?.getLayers();
    allLayers?.forEach((taskLayer: any) => {
      if (taskLayer?.uniqueID && marker.uniqueID && taskLayer?.uniqueID === marker.uniqueID
        && marker?.type && taskLayer?.type && taskLayer?.type === marker.type
      ) {
        isDuplicate = true;
      }
    })
    return isDuplicate;
  }

  /**
   * Method checks if the generated number marker is duplicate or not
   * @param marker number marker object
   * @returns boolean value
   */
  checkDuplicateNumberMarker(marker:CustomMarkerType){
    let isDuplicate = false;
    let allLayers = this.layerGroup?.getLayers();
    allLayers?.forEach((taskLayer: any) => {
      if (taskLayer?.uniqueID &&  taskLayer?.uniqueID=='OTFGUID'){
        let numberLayer = taskLayer?.getLayers() && taskLayer?.getLayers();
        let checkLayers = taskLayer;
        if(numberLayer){
          checkLayers = numberLayer;
          checkLayers.forEach((checkLayer:any) => {
            if (checkLayer?.uniqueID && marker.uniqueID && checkLayer?.uniqueID === marker.uniqueID
              && marker?.type && checkLayer?.type && checkLayer?.type === marker.type
            ) {
              isDuplicate = true;
            }
          });
        }
      }
    })
    return isDuplicate;
  }

  /**
   * Method updates the map view on delta updates by clerning and replotting the markers
   * @param deltaUpdates delta object of other tasks
   */
  updateOtherTaskOnDelta(deltaUpdates: any){
    if(deltaUpdates?.isDeltaUpdate && (deltaUpdates?.deltaTasks?.length||deltaUpdates?.removedTasks?.length)){
      this.mapLeafletService.markers = [];
      this.layerGroup?.clearLayers();
      this.gpsMarkerFG?.clearLayers();
      this.gpsMarkerMap.clear();
      this.gpsDataMap.clear();
      let center = this.map?.getCenter();
      this.setBLMarker(this.dataRepositoryService.blCoordinates);
      this.setMapFocus({latitude:center?.lat, longitude: center?.lng},this.currentZoomLevel);
    }
  }

  /**
   * Method generates the circle marker for other types (UPP/UL/PL-PBM/PTC) of task (non-planned task)
   * @param markerData task list object
   * @param type optional type string 
   * @returns circle marker object
   */
  generateOtherTaskCircleMarker(markerData: any, type?: string) {
    //If the task has been completed then color should Green else regular route associated color.
    const coords = this.getCoordinates(markerData);
    let circleMarker: customCircleMarkerType = L.circleMarker(
      [
        coords.latitude,
        coords.longitude,
      ],
      {
        radius: 10,
        color: "black",
        fillColor: "black",
        fillOpacity: 1.0,
      }
    );

    circleMarker.uniqueID =
      this.taskInfoService.selectedTabName.toLowerCase() != TBTabName.Unloaded
        ? markerData.task_id ?? ""
        : markerData.item_id ?? "";
    circleMarker.isSelected = false;
    circleMarker.type = 'circle-marker';
    circleMarker.addTo && this.layerGroup && circleMarker.addTo(this.layerGroup);
    let tooltipText = this.taskInfoService.selectedTabName.toLowerCase() == TBTabName.Unplannedpickup
    || this.taskInfoService.selectedTabName.toLowerCase() == TBTabName.PlannedPBM 
    ? markerData.pbm_order_id
    : markerData.task_point_name??'N/A'
    circleMarker.bindPopup && circleMarker?.bindPopup(`<b>${tooltipText}</b>`)
    
    circleMarker?.addEventListener?.("click", (event: any) => {
      /** USE below code for click actions
       const taskId = event?.target?.uniqueID;
        const parentId = event?.target?.parentId;
        this.selectTaskOnMap(taskId, parentId);
        this.setTaskSelection(taskId);
        * 
        */
    });

    return circleMarker;
  }

  /**
   * Method generates the number marker for other types (UPP/UL/PL-PBM/PTC) of task (non-planned task)
   * @param numberData task list object
   * @param type optional type string
   * @returns number marker object
   */
  generateOtherTaskNumberMarker(numberData: any, index: number): CustomMarkerType {
    let textColor = "#FFFFFF";
    let textMargin = "0vh";
    // let fontSize = '12px'

    // Adjust text positioning based on the length of the number
    if (numberData.index.toString().length === 2) {
      textMargin = "-17%";
    } else if (numberData.index.toString().length === 3) {
      textMargin = "-45%";
    } else if (numberData.index.toString().length === 4) {
      textMargin = "-86%";
    }

    // Define text style for the marker
    let textStyle = `text-align:center; font-weight:bold; color: ${textColor}; margin-left: ${textMargin};`;

    // Create a text icon with dynamic index
    let textIcon = L.divIcon({
      className: "text-label numberStyle",
      html: `<div style="${textStyle}">${numberData.index}</div>`,
      iconSize: [10, 10],
      iconAnchor: [5, 10],
    });

    // Create the number marker using Leaflet's L.marker
    const coords = this.getCoordinates(numberData);
    let numberMarker: CustomMarkerType = L.marker(
      [
        coords.latitude,
        coords.longitude,
      ],
      { icon: textIcon }
    );

    // Assign unique properties to the marker
    numberMarker.uniqueID = numberData.task_id;
    numberMarker.type = 'number-marker';
    let tooltipText = this.taskInfoService.selectedTabName.toLowerCase() == TBTabName.Unplannedpickup
    || this.taskInfoService.selectedTabName.toLowerCase() == TBTabName.PlannedPBM 
    ? numberData.pbm_order_id
    : numberData.task_point_name??'N/A'
    numberMarker.bindPopup && numberMarker?.bindPopup(`<b>${tooltipText}</b>`)
    // Add click event listener if required
    numberMarker?.addEventListener?.("click", (event: any) => {
      /**
       * Use below for click event actions
      const taskId = event?.target?.uniqueID;
      console.log(`Task clicked: ${taskId}`);
        */
    });

    return numberMarker;
  } 

  /**
   * Method takes stop details and generate circle marker
   * @param stopData stop details of a given route
   * @returns generated circle marker
   */
  generateStopCircleMarker(stopData: any): customCircleMarkerType {
    //circle
    /**
     * If the stop has been completed then color should Green else regular route associated color.
     */
    let circleMarker: customCircleMarkerType;
    circleMarker = L.circleMarker(
      [
        stopData.stop_coordinate?.latitude ?? stopData.coordinate.latitude,
        stopData.stop_coordinate?.longitude ?? stopData.coordinate.longitude,
      ],
      {
        radius: this.isZoomLessThanThreshold ? 4 : 8,
        color: stopData?.stop_state?.toLowerCase() === StopState.Completed
          ? "Green" : this.dataRepositoryService.routesColour.get(stopData.route_id),
        fillColor: stopData?.stop_state?.toLowerCase() === StopState.Completed
          ? "Green"
          : this.dataRepositoryService.routesColour.get(
            stopData.route_id
          ),
        fillOpacity: 1.0,
      }
    );

    circleMarker.uniqueID = stopData.stop_id ?? "";
    circleMarker.parentId = stopData.route_id ?? "";
    circleMarker.isSelected = false;
    circleMarker?.addTo?.(this.layerGroup);

    circleMarker?.addEventListener?.("click", (event: any) => {
      this.handleStopMarkerEvent(stopData);
    });
    return circleMarker;
  }

  /**
   * To handle circle marker click event
   * @param stopDatat - selected stop point data.
   */
  handleStopMarkerEvent(stopData: any) {
    if (this.currentZoomLevel >= this.zoomLevelForAddressPtMarker) {
      const markerId = stopData.stop_id;
      if (this.lastMarkerClickedId?.task_id === markerId) {
        this.hideMarkers();
        this.lastMarkerClickedId = { route_id: null, task_id: null };
      }
      else {
        this.hideMarkers();
        this.drawRoutePoints(stopData);
        this.lastMarkerClickedId = { route_id: stopData.route_id, task_id: markerId };
      }
    }
  }

  /**
   * Method generates the number marker for the given stop
   * @param stopData sto details for a given route
   * @returns number marker for the given stop
   */
  generateStopNumberMarker(stopData: any): CustomMarkerType {
    let strokeColor = "yellow";
    let textColor = "#FFFFFF";
    let numberMarker: CustomMarkerType;
    let textStyle = `text-align:center; font-weight:bold; stroke: ${strokeColor}; color: ${textColor};`;

    let textIcon = L.divIcon({
      className: "text-label numberStyle",
      html: `<div style="${textStyle}">${stopData.stop_sequence}</div>`,
      iconSize: [10, 10],
      iconAnchor: [5, 10],
    });

    numberMarker = L.marker(
      [
        stopData.stop_coordinate?.latitude ?? stopData.coordinate.latitude,
        stopData.stop_coordinate?.longitude ?? stopData.coordinate.longitude,
      ],
      { icon: textIcon }
    );
    numberMarker.uniqueID = stopData.stop_id;
    numberMarker.parentId = stopData.route_id;
    numberMarker?.addTo?.(this.layerGroup);

    numberMarker?.addEventListener?.("click", (event: any) => {
      this.handleStopMarkerEvent(stopData);
    });
    return numberMarker;
  }

  /**
   * Method extracts the available coordinates from the input object,
   * it first checks task object, if not available then stop object 
   * and last takes coordinate object. 
   * @param data Object represents task or item data
   * @returns object contains latitude and longitude
   */
  getCoordinates(data:any){
    return {
      latitude: data.task_coordinate?.latitude ?? data.stop_coordinate?.latitude ?? data.coordinate?.latitude,
      longitude: data.task_coordinate?.longitude ?? data.stop_coordinate?.longitude ?? data.coordinate?.longitude
    }
  }

  //*********************General utility methods*****************//

  /**
   * Method creates the toaster message
   * @param msg input message string
   * @param msgType type fo the message (Error/Warning/Success)
   */
  informUser(msg: string, msgType: string) {
    this.messageService.add({
      severity: msgType,
      summary: "",
      detail: msg,
    });
  }

  /**
   * Method scrolls the view to the top
   */
  scrollToTop() {
    if (this.mapTable) {
      this.mapTable.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }

  /**
   * Method handles the Map plotting based on the selected view option (Stop view / Task view)
   * @param event selected view option
   */
  selectView(event: any) {
    this.removePolygon();
    this.layerGroup.clearLayers();
    this.gpsMarkerFG?.clearLayers();
    this.gpsMarkerMap.clear();
    this.gpsDataMap.clear();
    this.clearGPSSubscription();
    [...this.dataRepositoryService.plannedTbCollection.values()].forEach(
      (m) => (m.isSelectedByMap = false)
    );
    this.dataRepositoryService.highlightedTaskOnMap.clear();
    this.setBLMarker(this.dataRepositoryService.blCoordinates);
    switch (event.value.toLowerCase()) {
      case MapViews.TaskView:
        //update the dropdown option 
        this.taskViewSelected();
        this.selectedView = MapViews.TaskView;
        break;
      case MapViews.StopView:
        //calling delta API and updating the collections
        this.isStopView = true;
        {
          let event = this.taskInfoService.taskBankTabs[0];
          this.taskInfoService.switchTAB(event);
        }
        if (this.mapData.length) {
        } else {
          this.informUser(WarningMessage.NOROUTEDATA, ErrorType.WARNING);
        }
        break;
      case TBTabName.Unplannedpickup:
        {
          let event = this.taskInfoService.taskBankTabs[1];
          this.taskInfoService.switchTAB(event);
        }
        break;
      case TBTabName.Unloaded:
        {
          let event = this.taskInfoService.taskBankTabs[2];
          this.taskInfoService.switchTAB(event);
        }

        break;
      case TBTabName.PlannedPBM:
        {
          let event = this.taskInfoService.taskBankTabs[3];
          this.taskInfoService.switchTAB(event);
        }

        break;
      case TBTabName.PushToCloud:
        {
          let event = this.taskInfoService.taskBankTabs[4];
          this.taskInfoService.switchTAB(event);
        }
        break;
        /**
         * Use below case if Merged view is enabled
         * 
        case MapViews.Merged_PL_UPP_View:
          {
            //plot task view first 
            this.taskViewSelected();
  
            //plot UPP view 
            this.mergedViewSelected();
  
            //update dropdown option 
            this.selectedView = MapViews.Merged_PL_UPP_View;
          }
          break;
         */
    }
  }

  /**
   * Method handles the taks view selection and updates the 
   * necessary variables and flags 
   */
  taskViewSelected(){
    this.taskInfoService.isViewChangedToPlanned = true;

    //calling delta API and updating the collections
    {
      let event = this.taskInfoService.taskBankTabs[0];
      this.taskInfoService.switchTAB(event);
    }
    this.isStopView = false;
    this.mapData = this.sortBySequence(
      this.mapData,
      PlannedSequenceType.TaskSequence
    );
  }

  /**
   * Method handles the merged view of Planned and Unplanned-pickup
   * tasks, it check the Unplannedpickup data or fetch it, then
   * calls the plotting methods
   */
  mergedViewSelected(){
    if(this.unplannedData){
      this.plotOtherTasks(this.unplannedData);
    }
    else{
      this.taskInfoService.getUnplannedPickupDeltaOnce();
    }
  }

  /**
   * Method sets the section visibility based on input number
   * @param section section number
   */
  setSectionVisibility(section: number) {
    this.sectionVisible = section;
    this.isTableCollapsed = this.sectionVisible == 1;
  }

  /**
  * This method helps to toggle KPI table expand collapse functionality
  */
  toggleTable() {
    this.isTableCollapsed = !this.isTableCollapsed;
  }

  /**
   * Method sorts the input collection based on the key property
   * @param data data collection to be sorted
   * @param sortby key property to be sorted on
   * @returns sorted collection
   */
  sortBySequence(data: any, sortby: string) {
    return data.sort((a: any, b: any) => (a[sortby] < b[sortby] ? -1 : 1));
  }


  /*****************General utility methods END ***************/

  /*******************Polygon drawing and handling methods START***** */
  
  /**
   *  This method removes all polygons drawn on the layer.
   */
  removePolygon() {
    this.drawnShapes.clearLayers();
    this.drawnPolygonMap.clear();
  }

  /**
   * Method updates and syncs dropdown option of selection view based on the selectred tab name 
   * from task bank
   */
  checkTabSelection(){
    switch (this.taskInfoService.selectedTabName.toLowerCase()) {
      case TBTabName.Planned.toLowerCase():
        this.selectedView = MapViews.TaskView;
        break;
      case TBTabName.Unplannedpickup.toLowerCase():
        this.selectedView = TBTabName.Unplannedpickup;
        break;

      case TBTabName.PlannedPBM.toLowerCase():
        this.selectedView = TBTabName.PlannedPBM;
        break;
      case TBTabName.Unloaded.toLowerCase():
        this.selectedView = TBTabName.Unloaded;
        break;
      case TBTabName.PushToCloud.toLowerCase():
        this.selectedView = TBTabName.PushToCloud;
        break;
    }
  }

  /**
   * Method takes polygon layer and update it with revalidating the markers inside it
   * and changes which has happened during delta update.
   * @param polygon polygon layer object which needs to be updated
   */
  updatePolygon(polygon: any, isDeltaUpdate?: boolean){
    //get marker inside the polygon
    let newMarkersInsidePolygon: L.Marker[] =
      this.mapLeafletService.getFeaturesInsidePolygon(polygon);

    //check unique id
    let oldLayer = this.drawnPolygonMap.get(polygon.uniqueID);

    let previousMarkersInsidePolygon = oldLayer.markerList;

    //removed preivous markers
    let removedMarkers = previousMarkersInsidePolygon.filter(
      (previous: any) =>
        !newMarkersInsidePolygon
          .map((m: any) => m.uniqueID)
          .includes(previous.uniqueID)
    );

    //update the polygon-map with markerList when change occurred in marker count
    let updatedLayer = this.drawnPolygonMap.get(polygon.uniqueID);
    updatedLayer.markerList = newMarkersInsidePolygon;
    this.drawnPolygonMap.set(polygon.uniqueID, updatedLayer);

    //added new markers
    if(!isDeltaUpdate){
      /**
       * NOTE: below add feature is commented, if business in future wants to conve the new added
       * marker (during delta updates) which appear in the polygon, then uncomment below code and use it.
       * 
      let addedMarkers = newMarkersInsidePolygon.filter(
        (newMarker: any) =>
          !previousMarkersInsidePolygon
            .map((m: any) => m.uniqueID)
            .includes(newMarker.uniqueID)
      );
       */

      //check among newMarkersInsidePolygon collection which all are not present in TaskMovement list
      let addedMarkers = newMarkersInsidePolygon.filter(
        (newMarker: any) =>
          !this.taskMovementService.selectedOptionsForTaskMove
            .map((task: any) => task.task_id)
            .includes(newMarker.uniqueID)
      );
  
      //Update task movement list for addedMarker
      if (addedMarkers.length) {
        if(this.taskInfoService.selectedTabName.toLowerCase()===TBTabName.Planned){
          this.setTaskMovementForPolygonsEdit(addedMarkers);
        }
        this.mapLeafletService.getPolygonSelectedTaskInfo(addedMarkers);
      }
    }

    //update task movement list for removed marker
    if (removedMarkers.length) {
      if(this.taskInfoService.selectedTabName.toLowerCase()===TBTabName.Planned){
        this.setTaskRemoveFromPolygonEdit(removedMarkers);
      }
      this.mapLeafletService.getPolygonDeselectedTaskInfo(removedMarkers);

    }
  }

  /*******************Polygon drawing and handling methods END***** */
}
